/* eslint-disable */
/* tslint:disable */

//////////////////////////////////////////////////////////////////////////////
/// Autogenerated by tailwindcss-classnames CLI. https://git.io/JtsPU
/// DO NOT EDIT THIS FILE DIRECTLY!
//////////////////////////////////////////////////////////////////////////////


import classnamesLib from 'clsx';
import type TCustomClassesFromExternalFile from './tailwindcss.customClasses';

export type TScreenReaders =
  | 'sr-only'
  | 'not-sr-only'

export type TAccessibility =
  | TScreenReaders

export type TBackgroundAttachment =
  | 'bg-fixed'
  | 'bg-local'
  | 'bg-scroll'

export type TBackgroundClip =
  | 'bg-clip-border'
  | 'bg-clip-padding'
  | 'bg-clip-content'
  | 'bg-clip-text'

export type TBackgroundOrigin =
  | 'bg-origin-border'
  | 'bg-origin-padding'
  | 'bg-origin-content'

export type TBackgroundRepeat =
  | 'bg-repeat'
  | 'bg-no-repeat'
  | 'bg-repeat-x'
  | 'bg-repeat-y'
  | 'bg-repeat-round'
  | 'bg-repeat-space'

export type TBackgroundOpacity =
  | 'bg-opacity-0'
  | 'bg-opacity-5'
  | 'bg-opacity-10'
  | 'bg-opacity-20'
  | 'bg-opacity-25'
  | 'bg-opacity-30'
  | 'bg-opacity-40'
  | 'bg-opacity-50'
  | 'bg-opacity-60'
  | 'bg-opacity-70'
  | 'bg-opacity-75'
  | 'bg-opacity-80'
  | 'bg-opacity-90'
  | 'bg-opacity-95'
  | 'bg-opacity-100'

export type TBackgroundColor =
  | 'bg-transparent'
  | 'bg-white'
  | 'bg-white-opacity'
  | 'bg-black'
  | 'bg-blue-100'
  | 'bg-grey-100'
  | 'bg-grey-200'
  | 'bg-grey-300'
  | 'bg-grey-700'
  | 'bg-grey-800'
  | 'bg-grey-900'
  | 'bg-grey-950'
  | 'bg-red-100'

export type TBackgroundPosition =
  | 'bg-bottom'
  | 'bg-center'
  | 'bg-left'
  | 'bg-left-bottom'
  | 'bg-left-top'
  | 'bg-right'
  | 'bg-right-bottom'
  | 'bg-right-top'
  | 'bg-top'

export type TBackgroundSize =
  | 'bg-auto'
  | 'bg-cover'
  | 'bg-contain'

export type TBackgroundImage =
  | 'bg-none'
  | 'bg-gradient-to-t'
  | 'bg-gradient-to-tr'
  | 'bg-gradient-to-r'
  | 'bg-gradient-to-br'
  | 'bg-gradient-to-b'
  | 'bg-gradient-to-bl'
  | 'bg-gradient-to-l'
  | 'bg-gradient-to-tl'

export type TGradientColorStops =
  | 'from-transparent'
  | 'via-transparent'
  | 'to-transparent'
  | 'from-white'
  | 'via-white'
  | 'to-white'
  | 'from-white-opacity'
  | 'via-white-opacity'
  | 'to-white-opacity'
  | 'from-black'
  | 'via-black'
  | 'to-black'
  | 'from-blue-100'
  | 'via-blue-100'
  | 'to-blue-100'
  | 'from-grey-100'
  | 'via-grey-100'
  | 'to-grey-100'
  | 'from-grey-200'
  | 'via-grey-200'
  | 'to-grey-200'
  | 'from-grey-300'
  | 'via-grey-300'
  | 'to-grey-300'
  | 'from-grey-700'
  | 'via-grey-700'
  | 'to-grey-700'
  | 'from-grey-800'
  | 'via-grey-800'
  | 'to-grey-800'
  | 'from-grey-900'
  | 'via-grey-900'
  | 'to-grey-900'
  | 'from-grey-950'
  | 'via-grey-950'
  | 'to-grey-950'
  | 'from-red-100'
  | 'via-red-100'
  | 'to-red-100'

export type TBackgrounds =
  | TBackgroundAttachment
  | TBackgroundClip
  | TBackgroundOrigin
  | TBackgroundRepeat
  | TBackgroundOpacity
  | TBackgroundColor
  | TBackgroundPosition
  | TBackgroundSize
  | TBackgroundImage
  | TGradientColorStops

export type TBorderStyle =
  | 'border-solid'
  | 'border-dashed'
  | 'border-dotted'
  | 'border-double'
  | 'border-hidden'
  | 'border-none'

export type TDivideStyle =
  | 'divide-solid'
  | 'divide-dashed'
  | 'divide-dotted'
  | 'divide-double'
  | 'divide-none'

export type TOutlineStyle =
  | 'outline'
  | 'outline-dashed'
  | 'outline-dotted'
  | 'outline-double'
  | 'outline-hidden'
  | 'outline-none'

export type TBorderColor =
  | 'border-transparent'
  | 'border-t-transparent'
  | 'border-r-transparent'
  | 'border-b-transparent'
  | 'border-l-transparent'
  | 'border-white'
  | 'border-t-white'
  | 'border-r-white'
  | 'border-b-white'
  | 'border-l-white'
  | 'border-white-opacity'
  | 'border-t-white-opacity'
  | 'border-r-white-opacity'
  | 'border-b-white-opacity'
  | 'border-l-white-opacity'
  | 'border-black'
  | 'border-t-black'
  | 'border-r-black'
  | 'border-b-black'
  | 'border-l-black'
  | 'border-blue-100'
  | 'border-t-blue-100'
  | 'border-r-blue-100'
  | 'border-b-blue-100'
  | 'border-l-blue-100'
  | 'border-grey-100'
  | 'border-t-grey-100'
  | 'border-r-grey-100'
  | 'border-b-grey-100'
  | 'border-l-grey-100'
  | 'border-grey-200'
  | 'border-t-grey-200'
  | 'border-r-grey-200'
  | 'border-b-grey-200'
  | 'border-l-grey-200'
  | 'border-grey-300'
  | 'border-t-grey-300'
  | 'border-r-grey-300'
  | 'border-b-grey-300'
  | 'border-l-grey-300'
  | 'border-grey-700'
  | 'border-t-grey-700'
  | 'border-r-grey-700'
  | 'border-b-grey-700'
  | 'border-l-grey-700'
  | 'border-grey-800'
  | 'border-t-grey-800'
  | 'border-r-grey-800'
  | 'border-b-grey-800'
  | 'border-l-grey-800'
  | 'border-grey-900'
  | 'border-t-grey-900'
  | 'border-r-grey-900'
  | 'border-b-grey-900'
  | 'border-l-grey-900'
  | 'border-grey-950'
  | 'border-t-grey-950'
  | 'border-r-grey-950'
  | 'border-b-grey-950'
  | 'border-l-grey-950'
  | 'border-red-100'
  | 'border-t-red-100'
  | 'border-r-red-100'
  | 'border-b-red-100'
  | 'border-l-red-100'

export type TBorderOpacity =
  | 'border-opacity-0'
  | 'border-opacity-5'
  | 'border-opacity-10'
  | 'border-opacity-20'
  | 'border-opacity-25'
  | 'border-opacity-30'
  | 'border-opacity-40'
  | 'border-opacity-50'
  | 'border-opacity-60'
  | 'border-opacity-70'
  | 'border-opacity-75'
  | 'border-opacity-80'
  | 'border-opacity-90'
  | 'border-opacity-95'
  | 'border-opacity-100'

export type TBorderRadius =
  | 'rounded-t-none'
  | 'rounded-r-none'
  | 'rounded-b-none'
  | 'rounded-l-none'
  | 'rounded-tr-none'
  | 'rounded-tl-none'
  | 'rounded-br-none'
  | 'rounded-bl-none'
  | 'rounded-none'
  | 'rounded-t-sm'
  | 'rounded-r-sm'
  | 'rounded-b-sm'
  | 'rounded-l-sm'
  | 'rounded-tr-sm'
  | 'rounded-tl-sm'
  | 'rounded-br-sm'
  | 'rounded-bl-sm'
  | 'rounded-sm'
  | 'rounded-t'
  | 'rounded-r'
  | 'rounded-b'
  | 'rounded-l'
  | 'rounded-tr'
  | 'rounded-tl'
  | 'rounded-br'
  | 'rounded-bl'
  | 'rounded'
  | 'rounded-t-md'
  | 'rounded-r-md'
  | 'rounded-b-md'
  | 'rounded-l-md'
  | 'rounded-tr-md'
  | 'rounded-tl-md'
  | 'rounded-br-md'
  | 'rounded-bl-md'
  | 'rounded-md'
  | 'rounded-t-lg'
  | 'rounded-r-lg'
  | 'rounded-b-lg'
  | 'rounded-l-lg'
  | 'rounded-tr-lg'
  | 'rounded-tl-lg'
  | 'rounded-br-lg'
  | 'rounded-bl-lg'
  | 'rounded-lg'
  | 'rounded-t-xl'
  | 'rounded-r-xl'
  | 'rounded-b-xl'
  | 'rounded-l-xl'
  | 'rounded-tr-xl'
  | 'rounded-tl-xl'
  | 'rounded-br-xl'
  | 'rounded-bl-xl'
  | 'rounded-xl'
  | 'rounded-t-2xl'
  | 'rounded-r-2xl'
  | 'rounded-b-2xl'
  | 'rounded-l-2xl'
  | 'rounded-tr-2xl'
  | 'rounded-tl-2xl'
  | 'rounded-br-2xl'
  | 'rounded-bl-2xl'
  | 'rounded-2xl'
  | 'rounded-t-3xl'
  | 'rounded-r-3xl'
  | 'rounded-b-3xl'
  | 'rounded-l-3xl'
  | 'rounded-tr-3xl'
  | 'rounded-tl-3xl'
  | 'rounded-br-3xl'
  | 'rounded-bl-3xl'
  | 'rounded-3xl'
  | 'rounded-t-full'
  | 'rounded-r-full'
  | 'rounded-b-full'
  | 'rounded-l-full'
  | 'rounded-tr-full'
  | 'rounded-tl-full'
  | 'rounded-br-full'
  | 'rounded-bl-full'
  | 'rounded-full'

export type TBorderWidth =
  | 'border-t-0'
  | 'border-r-0'
  | 'border-b-0'
  | 'border-l-0'
  | 'border-x-0'
  | 'border-y-0'
  | 'border-0'
  | 'border-t-2'
  | 'border-r-2'
  | 'border-b-2'
  | 'border-l-2'
  | 'border-x-2'
  | 'border-y-2'
  | 'border-2'
  | 'border-t-4'
  | 'border-r-4'
  | 'border-b-4'
  | 'border-l-4'
  | 'border-x-4'
  | 'border-y-4'
  | 'border-4'
  | 'border-t-8'
  | 'border-r-8'
  | 'border-b-8'
  | 'border-l-8'
  | 'border-x-8'
  | 'border-y-8'
  | 'border-8'
  | 'border-t'
  | 'border-r'
  | 'border-b'
  | 'border-l'
  | 'border-x'
  | 'border-y'
  | 'border'

export type TDivideColor =
  | 'divide-transparent'
  | 'divide-white'
  | 'divide-white-opacity'
  | 'divide-black'
  | 'divide-blue-100'
  | 'divide-grey-100'
  | 'divide-grey-200'
  | 'divide-grey-300'
  | 'divide-grey-700'
  | 'divide-grey-800'
  | 'divide-grey-900'
  | 'divide-grey-950'
  | 'divide-red-100'

export type TDivideOpacity =
  | 'divide-opacity-0'
  | 'divide-opacity-5'
  | 'divide-opacity-10'
  | 'divide-opacity-20'
  | 'divide-opacity-25'
  | 'divide-opacity-30'
  | 'divide-opacity-40'
  | 'divide-opacity-50'
  | 'divide-opacity-60'
  | 'divide-opacity-70'
  | 'divide-opacity-75'
  | 'divide-opacity-80'
  | 'divide-opacity-90'
  | 'divide-opacity-95'
  | 'divide-opacity-100'

export type TDivideWidth =
  | 'divide-x-0'
  | 'divide-y-0'
  | 'divide-x-2'
  | 'divide-y-2'
  | 'divide-x-4'
  | 'divide-y-4'
  | 'divide-x-8'
  | 'divide-y-8'
  | 'divide-x'
  | 'divide-y'
  | 'divide-x-reverse'
  | 'divide-y-reverse'

export type TRingColor =
  | 'ring-transparent'
  | 'ring-white'
  | 'ring-white-opacity'
  | 'ring-black'
  | 'ring-blue-100'
  | 'ring-grey-100'
  | 'ring-grey-200'
  | 'ring-grey-300'
  | 'ring-grey-700'
  | 'ring-grey-800'
  | 'ring-grey-900'
  | 'ring-grey-950'
  | 'ring-red-100'

export type TRingWidth =
  | 'ring-0'
  | 'ring-1'
  | 'ring-2'
  | 'ring-4'
  | 'ring-8'
  | 'ring'
  | 'ring-inset'

export type TRingOpacity =
  | 'ring-opacity-0'
  | 'ring-opacity-5'
  | 'ring-opacity-10'
  | 'ring-opacity-20'
  | 'ring-opacity-25'
  | 'ring-opacity-30'
  | 'ring-opacity-40'
  | 'ring-opacity-50'
  | 'ring-opacity-60'
  | 'ring-opacity-70'
  | 'ring-opacity-75'
  | 'ring-opacity-80'
  | 'ring-opacity-90'
  | 'ring-opacity-95'
  | 'ring-opacity-100'
  | 'ring-opacity'

export type TRingOffsetColor =
  | 'ring-offset-transparent'
  | 'ring-offset-white'
  | 'ring-offset-white-opacity'
  | 'ring-offset-black'
  | 'ring-offset-blue-100'
  | 'ring-offset-grey-100'
  | 'ring-offset-grey-200'
  | 'ring-offset-grey-300'
  | 'ring-offset-grey-700'
  | 'ring-offset-grey-800'
  | 'ring-offset-grey-900'
  | 'ring-offset-grey-950'
  | 'ring-offset-red-100'

export type TRingOffsetWidth =
  | 'ring-offset-0'
  | 'ring-offset-1'
  | 'ring-offset-2'
  | 'ring-offset-4'
  | 'ring-offset-8'

export type TOutlineOffset =
  | 'outline-0'
  | 'outline-1'
  | 'outline-2'
  | 'outline-4'
  | 'outline-8'

export type TOutlineWidth =
  | 'outline-0'
  | 'outline-1'
  | 'outline-2'
  | 'outline-4'
  | 'outline-8'

export type TOutlineColor =
  | 'outline-transparent'
  | 'outline-white'
  | 'outline-white-opacity'
  | 'outline-black'
  | 'outline-blue-100'
  | 'outline-grey-100'
  | 'outline-grey-200'
  | 'outline-grey-300'
  | 'outline-grey-700'
  | 'outline-grey-800'
  | 'outline-grey-900'
  | 'outline-grey-950'
  | 'outline-red-100'

export type TBorders =
  | TBorderStyle
  | TDivideStyle
  | TOutlineStyle
  | TBorderColor
  | TBorderOpacity
  | TBorderRadius
  | TBorderWidth
  | TDivideColor
  | TDivideOpacity
  | TDivideWidth
  | TRingColor
  | TRingWidth
  | TRingOpacity
  | TRingOffsetColor
  | TRingOffsetWidth
  | TOutlineOffset
  | TOutlineWidth
  | TOutlineColor

export type TBorderCollapse =
  | 'border-collapse'
  | 'border-separate'

export type TTableLayout =
  | 'table-auto'
  | 'table-fixed'

export type TTables =
  | TBorderCollapse
  | TTableLayout

export type TMixBlendMode =
  | 'mix-blend-normal'
  | 'mix-blend-multiply'
  | 'mix-blend-screen'
  | 'mix-blend-overlay'
  | 'mix-blend-darken'
  | 'mix-blend-lighten'
  | 'mix-blend-color-dodge'
  | 'mix-blend-color-burn'
  | 'mix-blend-hard-light'
  | 'mix-blend-soft-light'
  | 'mix-blend-difference'
  | 'mix-blend-exclusion'
  | 'mix-blend-hue'
  | 'mix-blend-saturation'
  | 'mix-blend-color'
  | 'mix-blend-luminosity'

export type TBackgroundBlendMode =
  | 'bg-blend-normal'
  | 'bg-blend-multiply'
  | 'bg-blend-screen'
  | 'bg-blend-overlay'
  | 'bg-blend-darken'
  | 'bg-blend-lighten'
  | 'bg-blend-color-dodge'
  | 'bg-blend-color-burn'
  | 'bg-blend-hard-light'
  | 'bg-blend-soft-light'
  | 'bg-blend-difference'
  | 'bg-blend-exclusion'
  | 'bg-blend-hue'
  | 'bg-blend-saturation'
  | 'bg-blend-color'
  | 'bg-blend-luminosity'

export type TBoxShadow =
  | 'shadow-sm'
  | 'shadow'
  | 'shadow-md'
  | 'shadow-lg'
  | 'shadow-xl'
  | 'shadow-2xl'
  | 'shadow-inner'
  | 'shadow-none'
  | 'shadow-shades-outer'
  | 'shadow-shades-inner'

export type TBoxShadowColor =
  | 'shadow-transparent'
  | 'shadow-white'
  | 'shadow-white-opacity'
  | 'shadow-black'
  | 'shadow-blue-100'
  | 'shadow-grey-100'
  | 'shadow-grey-200'
  | 'shadow-grey-300'
  | 'shadow-grey-700'
  | 'shadow-grey-800'
  | 'shadow-grey-900'
  | 'shadow-grey-950'
  | 'shadow-red-100'

export type TOpacity =
  | 'opacity-0'
  | 'opacity-5'
  | 'opacity-10'
  | 'opacity-20'
  | 'opacity-25'
  | 'opacity-30'
  | 'opacity-40'
  | 'opacity-50'
  | 'opacity-60'
  | 'opacity-70'
  | 'opacity-75'
  | 'opacity-80'
  | 'opacity-90'
  | 'opacity-95'
  | 'opacity-100'

export type TEffects =
  | TMixBlendMode
  | TBackgroundBlendMode
  | TBoxShadow
  | TBoxShadowColor
  | TOpacity

export type TTransitionProperty =
  | 'transition-none'
  | 'transition-all'
  | 'transition'
  | 'transition-colors'
  | 'transition-opacity'
  | 'transition-shadow'
  | 'transition-transform'

export type TTransitionDuration =
  | 'duration-75'
  | 'duration-100'
  | 'duration-150'
  | 'duration-200'
  | 'duration-300'
  | 'duration-500'
  | 'duration-700'
  | 'duration-1000'
  | 'duration'

export type TTransitionTimingFunction =
  | 'ease-linear'
  | 'ease-in'
  | 'ease-out'
  | 'ease-in-out'

export type TTransitionDelay =
  | 'delay-75'
  | 'delay-100'
  | 'delay-150'
  | 'delay-200'
  | 'delay-300'
  | 'delay-500'
  | 'delay-700'
  | 'delay-1000'

export type TAnimation =
  | 'animate-none'
  | 'animate-spin'
  | 'animate-ping'
  | 'animate-pulse'
  | 'animate-bounce'

export type TTransitionsAndAnimations =
  | TTransitionProperty
  | TTransitionDuration
  | TTransitionTimingFunction
  | TTransitionDelay
  | TAnimation

export type TFilter =
  | 'filter'
  | 'filter-none'

export type TBackdropFilter =
  | 'backdrop-filter'
  | 'backdrop-filter-none'

export type TBlur =
  | 'blur-0'
  | 'blur-none'
  | 'blur-sm'
  | 'blur'
  | 'blur-md'
  | 'blur-lg'
  | 'blur-xl'
  | 'blur-2xl'
  | 'blur-3xl'

export type TBrightness =
  | 'brightness-0'
  | 'brightness-50'
  | 'brightness-75'
  | 'brightness-90'
  | 'brightness-95'
  | 'brightness-100'
  | 'brightness-105'
  | 'brightness-110'
  | 'brightness-125'
  | 'brightness-150'
  | 'brightness-200'

export type TContrast =
  | 'contrast-0'
  | 'contrast-50'
  | 'contrast-75'
  | 'contrast-100'
  | 'contrast-125'
  | 'contrast-150'
  | 'contrast-200'

export type TDropShadow =
  | 'drop-shadow-home'

export type TGrayscale =
  | 'grayscale-0'
  | 'grayscale'

export type THueRotate =
  | 'hue-rotate-0'
  | 'hue-rotate-15'
  | 'hue-rotate-30'
  | 'hue-rotate-60'
  | 'hue-rotate-90'
  | 'hue-rotate-180'

export type TInvert =
  | 'invert-0'
  | 'invert'

export type TSaturate =
  | 'saturate-0'
  | 'saturate-50'
  | 'saturate-100'
  | 'saturate-150'
  | 'saturate-200'

export type TSepia =
  | 'sepia-0'
  | 'sepia'

export type TBackdropBlur =
  | 'backdrop-blur-0'
  | 'backdrop-blur-none'
  | 'backdrop-blur-sm'
  | 'backdrop-blur'
  | 'backdrop-blur-md'
  | 'backdrop-blur-lg'
  | 'backdrop-blur-xl'
  | 'backdrop-blur-2xl'
  | 'backdrop-blur-3xl'

export type TBackdropBrightness =
  | 'backdrop-brightness-0'
  | 'backdrop-brightness-50'
  | 'backdrop-brightness-75'
  | 'backdrop-brightness-90'
  | 'backdrop-brightness-95'
  | 'backdrop-brightness-100'
  | 'backdrop-brightness-105'
  | 'backdrop-brightness-110'
  | 'backdrop-brightness-125'
  | 'backdrop-brightness-150'
  | 'backdrop-brightness-200'

export type TBackdropContrast =
  | 'backdrop-contrast-0'
  | 'backdrop-contrast-50'
  | 'backdrop-contrast-75'
  | 'backdrop-contrast-100'
  | 'backdrop-contrast-125'
  | 'backdrop-contrast-150'
  | 'backdrop-contrast-200'

export type TBackdropGrayscale =
  | 'backdrop-grayscale-0'
  | 'backdrop-grayscale'

export type TBackdropHueRotate =
  | 'backdrop-hue-rotate-0'
  | 'backdrop-hue-rotate-15'
  | 'backdrop-hue-rotate-30'
  | 'backdrop-hue-rotate-60'
  | 'backdrop-hue-rotate-90'
  | 'backdrop-hue-rotate-180'

export type TBackdropInvert =
  | 'backdrop-invert-0'
  | 'backdrop-invert'

export type TBackdropOpacity =
  | 'backdrop-opacity-0'
  | 'backdrop-opacity-5'
  | 'backdrop-opacity-10'
  | 'backdrop-opacity-20'
  | 'backdrop-opacity-25'
  | 'backdrop-opacity-30'
  | 'backdrop-opacity-40'
  | 'backdrop-opacity-50'
  | 'backdrop-opacity-60'
  | 'backdrop-opacity-70'
  | 'backdrop-opacity-75'
  | 'backdrop-opacity-80'
  | 'backdrop-opacity-90'
  | 'backdrop-opacity-95'
  | 'backdrop-opacity-100'

export type TBackdropSaturate =
  | 'backdrop-saturate-0'
  | 'backdrop-saturate-50'
  | 'backdrop-saturate-100'
  | 'backdrop-saturate-150'
  | 'backdrop-saturate-200'

export type TBackdropSepia =
  | 'backdrop-sepia-0'
  | 'backdrop-sepia'

export type TFilters =
  | TFilter
  | TBackdropFilter
  | TBlur
  | TBrightness
  | TContrast
  | TDropShadow
  | TGrayscale
  | THueRotate
  | TInvert
  | TSaturate
  | TSepia
  | TBackdropBlur
  | TBackdropBrightness
  | TBackdropContrast
  | TBackdropGrayscale
  | TBackdropHueRotate
  | TBackdropInvert
  | TBackdropOpacity
  | TBackdropSaturate
  | TBackdropSepia

export type TFlexDirection =
  | 'flex-row'
  | 'flex-row-reverse'
  | 'flex-col'
  | 'flex-col-reverse'

export type TFlexWrap =
  | 'flex-nowrap'
  | 'flex-wrap'
  | 'flex-wrap-reverse'

export type TAlignItems =
  | 'items-stretch'
  | 'items-start'
  | 'items-center'
  | 'items-end'
  | 'items-baseline'

export type TAlignContent =
  | 'content-start'
  | 'content-center'
  | 'content-end'
  | 'content-between'
  | 'content-around'

export type TAlignSelf =
  | 'self-auto'
  | 'self-start'
  | 'self-center'
  | 'self-end'
  | 'self-stretch'
  | 'self-baseline'

export type TPlaceContent =
  | 'place-content-start'
  | 'place-content-center'
  | 'place-content-end'
  | 'place-content-between'
  | 'place-content-around'
  | 'place-content-evenly'
  | 'place-content-stretch'

export type TPlaceItems =
  | 'place-items-auto'
  | 'place-items-start'
  | 'place-items-center'
  | 'place-items-end'
  | 'place-items-stretch'

export type TPlaceSelf =
  | 'place-self-auto'
  | 'place-self-start'
  | 'place-self-center'
  | 'place-self-end'
  | 'place-self-stretch'

export type TJustifyContent =
  | 'justify-start'
  | 'justify-center'
  | 'justify-end'
  | 'justify-between'
  | 'justify-around'
  | 'justify-evenly'

export type TJustifyItems =
  | 'justify-items-auto'
  | 'justify-items-start'
  | 'justify-items-center'
  | 'justify-items-end'
  | 'justify-items-stretch'

export type TJustifySelf =
  | 'justify-self-auto'
  | 'justify-self-start'
  | 'justify-self-center'
  | 'justify-self-end'
  | 'justify-self-stretch'

export type TFlex =
  | 'flex-initial'
  | 'flex-1'
  | 'flex-auto'
  | 'flex-none'

export type TFlexBasis =
  | 'basis-0'
  | 'basis-1'
  | 'basis-2'
  | 'basis-3'
  | 'basis-4'
  | 'basis-5'
  | 'basis-6'
  | 'basis-7'
  | 'basis-8'
  | 'basis-9'
  | 'basis-10'
  | 'basis-11'
  | 'basis-12'
  | 'basis-14'
  | 'basis-16'
  | 'basis-17'
  | 'basis-20'
  | 'basis-24'
  | 'basis-28'
  | 'basis-32'
  | 'basis-36'
  | 'basis-40'
  | 'basis-44'
  | 'basis-48'
  | 'basis-52'
  | 'basis-56'
  | 'basis-60'
  | 'basis-64'
  | 'basis-72'
  | 'basis-80'
  | 'basis-96'
  | 'basis-auto'
  | 'basis-px'
  | 'basis-0.5'
  | 'basis-1.5'
  | 'basis-2.5'
  | 'basis-3.5'
  | 'basis-1/2'
  | 'basis-1/3'
  | 'basis-2/3'
  | 'basis-1/4'
  | 'basis-2/4'
  | 'basis-3/4'
  | 'basis-1/5'
  | 'basis-2/5'
  | 'basis-3/5'
  | 'basis-4/5'
  | 'basis-1/6'
  | 'basis-2/6'
  | 'basis-3/6'
  | 'basis-4/6'
  | 'basis-5/6'
  | 'basis-1/12'
  | 'basis-2/12'
  | 'basis-3/12'
  | 'basis-4/12'
  | 'basis-5/12'
  | 'basis-6/12'
  | 'basis-7/12'
  | 'basis-8/12'
  | 'basis-9/12'
  | 'basis-10/12'
  | 'basis-11/12'
  | 'basis-full'

export type TFlexGrow =
  | 'grow-0'
  | 'grow'

export type TFlexShrink =
  | 'shrink-0'
  | 'shrink'

export type TOrder =
  | 'order-1'
  | 'order-2'
  | 'order-3'
  | 'order-4'
  | 'order-5'
  | 'order-6'
  | 'order-7'
  | 'order-8'
  | 'order-9'
  | 'order-10'
  | 'order-11'
  | 'order-12'
  | 'order-first'
  | 'order-last'
  | 'order-none'

export type TFlexBox =
  | TFlexDirection
  | TFlexWrap
  | TAlignItems
  | TAlignContent
  | TAlignSelf
  | TPlaceContent
  | TPlaceItems
  | TPlaceSelf
  | TJustifyContent
  | TJustifyItems
  | TJustifySelf
  | TFlex
  | TFlexBasis
  | TFlexGrow
  | TFlexShrink
  | TOrder

export type TGridAutoFlow =
  | 'grid-flow-row'
  | 'grid-flow-col'
  | 'grid-flow-row-dense'
  | 'grid-flow-col-dense'

export type TGridTemplateColumns =
  | 'grid-cols-1'
  | 'grid-cols-2'
  | 'grid-cols-3'
  | 'grid-cols-4'
  | 'grid-cols-5'
  | 'grid-cols-6'
  | 'grid-cols-7'
  | 'grid-cols-8'
  | 'grid-cols-9'
  | 'grid-cols-10'
  | 'grid-cols-11'
  | 'grid-cols-12'
  | 'grid-cols-none'
  | 'grid-cols-min-content-2'
  | 'grid-cols-responsive-buttons'

export type TGridAutoColumns =
  | 'auto-cols-auto'
  | 'auto-cols-min'
  | 'auto-cols-max'
  | 'auto-cols-fr'

export type TGridColumn =
  | 'col-auto'
  | 'col-span-1'
  | 'col-span-2'
  | 'col-span-3'
  | 'col-span-4'
  | 'col-span-5'
  | 'col-span-6'
  | 'col-span-7'
  | 'col-span-8'
  | 'col-span-9'
  | 'col-span-10'
  | 'col-span-11'
  | 'col-span-12'
  | 'col-span-full'

export type TGridColumnStart =
  | 'col-start-1'
  | 'col-start-2'
  | 'col-start-3'
  | 'col-start-4'
  | 'col-start-5'
  | 'col-start-6'
  | 'col-start-7'
  | 'col-start-8'
  | 'col-start-9'
  | 'col-start-10'
  | 'col-start-11'
  | 'col-start-12'
  | 'col-start-13'
  | 'col-start-auto'

export type TGridColumnEnd =
  | 'col-end-1'
  | 'col-end-2'
  | 'col-end-3'
  | 'col-end-4'
  | 'col-end-5'
  | 'col-end-6'
  | 'col-end-7'
  | 'col-end-8'
  | 'col-end-9'
  | 'col-end-10'
  | 'col-end-11'
  | 'col-end-12'
  | 'col-end-13'
  | 'col-end-auto'

export type TGridTemplateRows =
  | 'grid-rows-1'
  | 'grid-rows-2'
  | 'grid-rows-3'
  | 'grid-rows-4'
  | 'grid-rows-5'
  | 'grid-rows-6'
  | 'grid-rows-none'
  | 'grid-rows-4-min'
  | 'grid-rows-min-fc'
  | 'grid-rows-fc-min'
  | 'grid-rows-fc-min-2'
  | 'grid-rows-min-fc-min'
  | 'grid-rows-min-fc-min-2'
  | 'grid-rows-min-4-fc-min'
  | 'grid-rows-min-2-fc'
  | 'grid-rows-min-content-4'
  | 'grid-rows-min-content-5'
  | 'grid-rows-min-content-8'

export type TGridAutoRows =
  | 'auto-rows-auto'
  | 'auto-rows-min'
  | 'auto-rows-max'
  | 'auto-rows-fr'

export type TGridRow =
  | 'row-auto'
  | 'row-span-1'
  | 'row-span-2'
  | 'row-span-3'
  | 'row-span-4'
  | 'row-span-5'
  | 'row-span-6'
  | 'row-span-full'

export type TGridRowStart =
  | 'row-start-1'
  | 'row-start-2'
  | 'row-start-3'
  | 'row-start-4'
  | 'row-start-5'
  | 'row-start-6'
  | 'row-start-7'
  | 'row-start-auto'

export type TGridRowEnd =
  | 'row-end-1'
  | 'row-end-2'
  | 'row-end-3'
  | 'row-end-4'
  | 'row-end-5'
  | 'row-end-6'
  | 'row-end-7'
  | 'row-end-auto'

export type TGap =
  | 'gap-0'
  | 'gap-1'
  | 'gap-2'
  | 'gap-3'
  | 'gap-4'
  | 'gap-5'
  | 'gap-6'
  | 'gap-7'
  | 'gap-8'
  | 'gap-9'
  | 'gap-10'
  | 'gap-11'
  | 'gap-12'
  | 'gap-14'
  | 'gap-16'
  | 'gap-17'
  | 'gap-20'
  | 'gap-24'
  | 'gap-28'
  | 'gap-32'
  | 'gap-36'
  | 'gap-40'
  | 'gap-44'
  | 'gap-48'
  | 'gap-52'
  | 'gap-56'
  | 'gap-60'
  | 'gap-64'
  | 'gap-72'
  | 'gap-80'
  | 'gap-96'
  | 'gap-px'
  | 'gap-0.5'
  | 'gap-1.5'
  | 'gap-2.5'
  | 'gap-3.5'
  | 'gap-y-0'
  | 'gap-y-1'
  | 'gap-y-2'
  | 'gap-y-3'
  | 'gap-y-4'
  | 'gap-y-5'
  | 'gap-y-6'
  | 'gap-y-7'
  | 'gap-y-8'
  | 'gap-y-9'
  | 'gap-y-10'
  | 'gap-y-11'
  | 'gap-y-12'
  | 'gap-y-14'
  | 'gap-y-16'
  | 'gap-y-17'
  | 'gap-y-20'
  | 'gap-y-24'
  | 'gap-y-28'
  | 'gap-y-32'
  | 'gap-y-36'
  | 'gap-y-40'
  | 'gap-y-44'
  | 'gap-y-48'
  | 'gap-y-52'
  | 'gap-y-56'
  | 'gap-y-60'
  | 'gap-y-64'
  | 'gap-y-72'
  | 'gap-y-80'
  | 'gap-y-96'
  | 'gap-y-px'
  | 'gap-y-0.5'
  | 'gap-y-1.5'
  | 'gap-y-2.5'
  | 'gap-y-3.5'
  | 'gap-x-0'
  | 'gap-x-1'
  | 'gap-x-2'
  | 'gap-x-3'
  | 'gap-x-4'
  | 'gap-x-5'
  | 'gap-x-6'
  | 'gap-x-7'
  | 'gap-x-8'
  | 'gap-x-9'
  | 'gap-x-10'
  | 'gap-x-11'
  | 'gap-x-12'
  | 'gap-x-14'
  | 'gap-x-16'
  | 'gap-x-17'
  | 'gap-x-20'
  | 'gap-x-24'
  | 'gap-x-28'
  | 'gap-x-32'
  | 'gap-x-36'
  | 'gap-x-40'
  | 'gap-x-44'
  | 'gap-x-48'
  | 'gap-x-52'
  | 'gap-x-56'
  | 'gap-x-60'
  | 'gap-x-64'
  | 'gap-x-72'
  | 'gap-x-80'
  | 'gap-x-96'
  | 'gap-x-px'
  | 'gap-x-0.5'
  | 'gap-x-1.5'
  | 'gap-x-2.5'
  | 'gap-x-3.5'

export type TGrid =
  | TGridAutoFlow
  | TGridTemplateColumns
  | TGridAutoColumns
  | TGridColumn
  | TGridColumnStart
  | TGridColumnEnd
  | TGridTemplateRows
  | TGridAutoRows
  | TGridRow
  | TGridRowStart
  | TGridRowEnd
  | TGap

export type TGroup =
  | 'group'

export type TPeer =
  | 'peer'

export type TGrouping =
  | TGroup
  | TPeer

export type TPadding =
  | 'p-0'
  | 'p-1'
  | 'p-2'
  | 'p-3'
  | 'p-4'
  | 'p-5'
  | 'p-6'
  | 'p-7'
  | 'p-8'
  | 'p-9'
  | 'p-10'
  | 'p-11'
  | 'p-12'
  | 'p-14'
  | 'p-16'
  | 'p-17'
  | 'p-20'
  | 'p-24'
  | 'p-28'
  | 'p-32'
  | 'p-36'
  | 'p-40'
  | 'p-44'
  | 'p-48'
  | 'p-52'
  | 'p-56'
  | 'p-60'
  | 'p-64'
  | 'p-72'
  | 'p-80'
  | 'p-96'
  | 'p-px'
  | 'p-0.5'
  | 'p-1.5'
  | 'p-2.5'
  | 'p-3.5'
  | 'py-0'
  | 'py-1'
  | 'py-2'
  | 'py-3'
  | 'py-4'
  | 'py-5'
  | 'py-6'
  | 'py-7'
  | 'py-8'
  | 'py-9'
  | 'py-10'
  | 'py-11'
  | 'py-12'
  | 'py-14'
  | 'py-16'
  | 'py-17'
  | 'py-20'
  | 'py-24'
  | 'py-28'
  | 'py-32'
  | 'py-36'
  | 'py-40'
  | 'py-44'
  | 'py-48'
  | 'py-52'
  | 'py-56'
  | 'py-60'
  | 'py-64'
  | 'py-72'
  | 'py-80'
  | 'py-96'
  | 'py-px'
  | 'py-0.5'
  | 'py-1.5'
  | 'py-2.5'
  | 'py-3.5'
  | 'px-0'
  | 'px-1'
  | 'px-2'
  | 'px-3'
  | 'px-4'
  | 'px-5'
  | 'px-6'
  | 'px-7'
  | 'px-8'
  | 'px-9'
  | 'px-10'
  | 'px-11'
  | 'px-12'
  | 'px-14'
  | 'px-16'
  | 'px-17'
  | 'px-20'
  | 'px-24'
  | 'px-28'
  | 'px-32'
  | 'px-36'
  | 'px-40'
  | 'px-44'
  | 'px-48'
  | 'px-52'
  | 'px-56'
  | 'px-60'
  | 'px-64'
  | 'px-72'
  | 'px-80'
  | 'px-96'
  | 'px-px'
  | 'px-0.5'
  | 'px-1.5'
  | 'px-2.5'
  | 'px-3.5'
  | 'pt-0'
  | 'pt-1'
  | 'pt-2'
  | 'pt-3'
  | 'pt-4'
  | 'pt-5'
  | 'pt-6'
  | 'pt-7'
  | 'pt-8'
  | 'pt-9'
  | 'pt-10'
  | 'pt-11'
  | 'pt-12'
  | 'pt-14'
  | 'pt-16'
  | 'pt-17'
  | 'pt-20'
  | 'pt-24'
  | 'pt-28'
  | 'pt-32'
  | 'pt-36'
  | 'pt-40'
  | 'pt-44'
  | 'pt-48'
  | 'pt-52'
  | 'pt-56'
  | 'pt-60'
  | 'pt-64'
  | 'pt-72'
  | 'pt-80'
  | 'pt-96'
  | 'pt-px'
  | 'pt-0.5'
  | 'pt-1.5'
  | 'pt-2.5'
  | 'pt-3.5'
  | 'pr-0'
  | 'pr-1'
  | 'pr-2'
  | 'pr-3'
  | 'pr-4'
  | 'pr-5'
  | 'pr-6'
  | 'pr-7'
  | 'pr-8'
  | 'pr-9'
  | 'pr-10'
  | 'pr-11'
  | 'pr-12'
  | 'pr-14'
  | 'pr-16'
  | 'pr-17'
  | 'pr-20'
  | 'pr-24'
  | 'pr-28'
  | 'pr-32'
  | 'pr-36'
  | 'pr-40'
  | 'pr-44'
  | 'pr-48'
  | 'pr-52'
  | 'pr-56'
  | 'pr-60'
  | 'pr-64'
  | 'pr-72'
  | 'pr-80'
  | 'pr-96'
  | 'pr-px'
  | 'pr-0.5'
  | 'pr-1.5'
  | 'pr-2.5'
  | 'pr-3.5'
  | 'pb-0'
  | 'pb-1'
  | 'pb-2'
  | 'pb-3'
  | 'pb-4'
  | 'pb-5'
  | 'pb-6'
  | 'pb-7'
  | 'pb-8'
  | 'pb-9'
  | 'pb-10'
  | 'pb-11'
  | 'pb-12'
  | 'pb-14'
  | 'pb-16'
  | 'pb-17'
  | 'pb-20'
  | 'pb-24'
  | 'pb-28'
  | 'pb-32'
  | 'pb-36'
  | 'pb-40'
  | 'pb-44'
  | 'pb-48'
  | 'pb-52'
  | 'pb-56'
  | 'pb-60'
  | 'pb-64'
  | 'pb-72'
  | 'pb-80'
  | 'pb-96'
  | 'pb-px'
  | 'pb-0.5'
  | 'pb-1.5'
  | 'pb-2.5'
  | 'pb-3.5'
  | 'pl-0'
  | 'pl-1'
  | 'pl-2'
  | 'pl-3'
  | 'pl-4'
  | 'pl-5'
  | 'pl-6'
  | 'pl-7'
  | 'pl-8'
  | 'pl-9'
  | 'pl-10'
  | 'pl-11'
  | 'pl-12'
  | 'pl-14'
  | 'pl-16'
  | 'pl-17'
  | 'pl-20'
  | 'pl-24'
  | 'pl-28'
  | 'pl-32'
  | 'pl-36'
  | 'pl-40'
  | 'pl-44'
  | 'pl-48'
  | 'pl-52'
  | 'pl-56'
  | 'pl-60'
  | 'pl-64'
  | 'pl-72'
  | 'pl-80'
  | 'pl-96'
  | 'pl-px'
  | 'pl-0.5'
  | 'pl-1.5'
  | 'pl-2.5'
  | 'pl-3.5'

export type TMargin =
  | 'm-0'
  | 'm-1'
  | 'm-2'
  | 'm-3'
  | 'm-4'
  | 'm-5'
  | 'm-6'
  | 'm-7'
  | 'm-8'
  | 'm-9'
  | 'm-10'
  | 'm-11'
  | 'm-12'
  | 'm-14'
  | 'm-16'
  | 'm-17'
  | 'm-20'
  | 'm-24'
  | 'm-28'
  | 'm-32'
  | 'm-36'
  | 'm-40'
  | 'm-44'
  | 'm-48'
  | 'm-52'
  | 'm-56'
  | 'm-60'
  | 'm-64'
  | 'm-72'
  | 'm-80'
  | 'm-96'
  | 'm-auto'
  | 'm-px'
  | 'm-0.5'
  | 'm-1.5'
  | 'm-2.5'
  | 'm-3.5'
  | 'my-0'
  | 'my-1'
  | 'my-2'
  | 'my-3'
  | 'my-4'
  | 'my-5'
  | 'my-6'
  | 'my-7'
  | 'my-8'
  | 'my-9'
  | 'my-10'
  | 'my-11'
  | 'my-12'
  | 'my-14'
  | 'my-16'
  | 'my-17'
  | 'my-20'
  | 'my-24'
  | 'my-28'
  | 'my-32'
  | 'my-36'
  | 'my-40'
  | 'my-44'
  | 'my-48'
  | 'my-52'
  | 'my-56'
  | 'my-60'
  | 'my-64'
  | 'my-72'
  | 'my-80'
  | 'my-96'
  | 'my-auto'
  | 'my-px'
  | 'my-0.5'
  | 'my-1.5'
  | 'my-2.5'
  | 'my-3.5'
  | 'mx-0'
  | 'mx-1'
  | 'mx-2'
  | 'mx-3'
  | 'mx-4'
  | 'mx-5'
  | 'mx-6'
  | 'mx-7'
  | 'mx-8'
  | 'mx-9'
  | 'mx-10'
  | 'mx-11'
  | 'mx-12'
  | 'mx-14'
  | 'mx-16'
  | 'mx-17'
  | 'mx-20'
  | 'mx-24'
  | 'mx-28'
  | 'mx-32'
  | 'mx-36'
  | 'mx-40'
  | 'mx-44'
  | 'mx-48'
  | 'mx-52'
  | 'mx-56'
  | 'mx-60'
  | 'mx-64'
  | 'mx-72'
  | 'mx-80'
  | 'mx-96'
  | 'mx-auto'
  | 'mx-px'
  | 'mx-0.5'
  | 'mx-1.5'
  | 'mx-2.5'
  | 'mx-3.5'
  | 'mt-0'
  | 'mt-1'
  | 'mt-2'
  | 'mt-3'
  | 'mt-4'
  | 'mt-5'
  | 'mt-6'
  | 'mt-7'
  | 'mt-8'
  | 'mt-9'
  | 'mt-10'
  | 'mt-11'
  | 'mt-12'
  | 'mt-14'
  | 'mt-16'
  | 'mt-17'
  | 'mt-20'
  | 'mt-24'
  | 'mt-28'
  | 'mt-32'
  | 'mt-36'
  | 'mt-40'
  | 'mt-44'
  | 'mt-48'
  | 'mt-52'
  | 'mt-56'
  | 'mt-60'
  | 'mt-64'
  | 'mt-72'
  | 'mt-80'
  | 'mt-96'
  | 'mt-auto'
  | 'mt-px'
  | 'mt-0.5'
  | 'mt-1.5'
  | 'mt-2.5'
  | 'mt-3.5'
  | 'mr-0'
  | 'mr-1'
  | 'mr-2'
  | 'mr-3'
  | 'mr-4'
  | 'mr-5'
  | 'mr-6'
  | 'mr-7'
  | 'mr-8'
  | 'mr-9'
  | 'mr-10'
  | 'mr-11'
  | 'mr-12'
  | 'mr-14'
  | 'mr-16'
  | 'mr-17'
  | 'mr-20'
  | 'mr-24'
  | 'mr-28'
  | 'mr-32'
  | 'mr-36'
  | 'mr-40'
  | 'mr-44'
  | 'mr-48'
  | 'mr-52'
  | 'mr-56'
  | 'mr-60'
  | 'mr-64'
  | 'mr-72'
  | 'mr-80'
  | 'mr-96'
  | 'mr-auto'
  | 'mr-px'
  | 'mr-0.5'
  | 'mr-1.5'
  | 'mr-2.5'
  | 'mr-3.5'
  | 'mb-0'
  | 'mb-1'
  | 'mb-2'
  | 'mb-3'
  | 'mb-4'
  | 'mb-5'
  | 'mb-6'
  | 'mb-7'
  | 'mb-8'
  | 'mb-9'
  | 'mb-10'
  | 'mb-11'
  | 'mb-12'
  | 'mb-14'
  | 'mb-16'
  | 'mb-17'
  | 'mb-20'
  | 'mb-24'
  | 'mb-28'
  | 'mb-32'
  | 'mb-36'
  | 'mb-40'
  | 'mb-44'
  | 'mb-48'
  | 'mb-52'
  | 'mb-56'
  | 'mb-60'
  | 'mb-64'
  | 'mb-72'
  | 'mb-80'
  | 'mb-96'
  | 'mb-auto'
  | 'mb-px'
  | 'mb-0.5'
  | 'mb-1.5'
  | 'mb-2.5'
  | 'mb-3.5'
  | 'ml-0'
  | 'ml-1'
  | 'ml-2'
  | 'ml-3'
  | 'ml-4'
  | 'ml-5'
  | 'ml-6'
  | 'ml-7'
  | 'ml-8'
  | 'ml-9'
  | 'ml-10'
  | 'ml-11'
  | 'ml-12'
  | 'ml-14'
  | 'ml-16'
  | 'ml-17'
  | 'ml-20'
  | 'ml-24'
  | 'ml-28'
  | 'ml-32'
  | 'ml-36'
  | 'ml-40'
  | 'ml-44'
  | 'ml-48'
  | 'ml-52'
  | 'ml-56'
  | 'ml-60'
  | 'ml-64'
  | 'ml-72'
  | 'ml-80'
  | 'ml-96'
  | 'ml-auto'
  | 'ml-px'
  | 'ml-0.5'
  | 'ml-1.5'
  | 'ml-2.5'
  | 'ml-3.5'

export type TSpace =
  | 'space-x-0'
  | 'space-x-1'
  | 'space-x-2'
  | 'space-x-3'
  | 'space-x-4'
  | 'space-x-5'
  | 'space-x-6'
  | 'space-x-7'
  | 'space-x-8'
  | 'space-x-9'
  | 'space-x-10'
  | 'space-x-11'
  | 'space-x-12'
  | 'space-x-14'
  | 'space-x-16'
  | 'space-x-17'
  | 'space-x-20'
  | 'space-x-24'
  | 'space-x-28'
  | 'space-x-32'
  | 'space-x-36'
  | 'space-x-40'
  | 'space-x-44'
  | 'space-x-48'
  | 'space-x-52'
  | 'space-x-56'
  | 'space-x-60'
  | 'space-x-64'
  | 'space-x-72'
  | 'space-x-80'
  | 'space-x-96'
  | 'space-x-px'
  | 'space-x-0.5'
  | 'space-x-1.5'
  | 'space-x-2.5'
  | 'space-x-3.5'
  | 'space-x-reverse'
  | 'space-y-0'
  | 'space-y-1'
  | 'space-y-2'
  | 'space-y-3'
  | 'space-y-4'
  | 'space-y-5'
  | 'space-y-6'
  | 'space-y-7'
  | 'space-y-8'
  | 'space-y-9'
  | 'space-y-10'
  | 'space-y-11'
  | 'space-y-12'
  | 'space-y-14'
  | 'space-y-16'
  | 'space-y-17'
  | 'space-y-20'
  | 'space-y-24'
  | 'space-y-28'
  | 'space-y-32'
  | 'space-y-36'
  | 'space-y-40'
  | 'space-y-44'
  | 'space-y-48'
  | 'space-y-52'
  | 'space-y-56'
  | 'space-y-60'
  | 'space-y-64'
  | 'space-y-72'
  | 'space-y-80'
  | 'space-y-96'
  | 'space-y-px'
  | 'space-y-0.5'
  | 'space-y-1.5'
  | 'space-y-2.5'
  | 'space-y-3.5'
  | 'space-y-reverse'

export type TSpacing =
  | TPadding
  | TMargin
  | TSpace

export type TAppearance =
  | 'appearance-none'

export type TPointerEvents =
  | 'pointer-events-none'
  | 'pointer-events-auto'

export type TResize =
  | 'resize-none'
  | 'resize'
  | 'resize-y'
  | 'resize-x'

export type TUserSelect =
  | 'select-none'
  | 'select-text'
  | 'select-all'
  | 'select-auto'

export type TScrollSnap =
  | 'snap-start'
  | 'snap-end'
  | 'snap-center'
  | 'snap-align-none'
  | 'snap-normal'
  | 'snap-always'
  | 'snap-none'
  | 'snap-x'
  | 'snap-y'
  | 'snap-both'
  | 'snap-mandatory'
  | 'snap-proximity'

export type TScrollBehavior =
  | 'scroll-auto'
  | 'scroll-smooth'

export type TTouchAction =
  | 'touch-auto'
  | 'touch-none'
  | 'touch-pan-x'
  | 'touch-pan-left'
  | 'touch-pan-right'
  | 'touch-pan-y'
  | 'touch-pan-up'
  | 'touch-pan-down'
  | 'touch-pinch-zoom'
  | 'touch-manipulation'

export type TCursor =
  | 'cursor-auto'
  | 'cursor-default'
  | 'cursor-pointer'
  | 'cursor-wait'
  | 'cursor-text'
  | 'cursor-move'
  | 'cursor-help'
  | 'cursor-not-allowed'
  | 'cursor-none'
  | 'cursor-context-menu'
  | 'cursor-progress'
  | 'cursor-cell'
  | 'cursor-crosshair'
  | 'cursor-vertical-text'
  | 'cursor-alias'
  | 'cursor-copy'
  | 'cursor-no-drop'
  | 'cursor-grab'
  | 'cursor-grabbing'
  | 'cursor-all-scroll'
  | 'cursor-col-resize'
  | 'cursor-row-resize'
  | 'cursor-n-resize'
  | 'cursor-e-resize'
  | 'cursor-s-resize'
  | 'cursor-w-resize'
  | 'cursor-ne-resize'
  | 'cursor-nw-resize'
  | 'cursor-se-resize'
  | 'cursor-sw-resize'
  | 'cursor-ew-resize'
  | 'cursor-ns-resize'
  | 'cursor-nesw-resize'
  | 'cursor-nwse-resize'
  | 'cursor-zoom-in'
  | 'cursor-zoom-out'

export type TCaretColor =
  | 'caret-transparent'
  | 'caret-white'
  | 'caret-white-opacity'
  | 'caret-black'
  | 'caret-blue-100'
  | 'caret-grey-100'
  | 'caret-grey-200'
  | 'caret-grey-300'
  | 'caret-grey-700'
  | 'caret-grey-800'
  | 'caret-grey-900'
  | 'caret-grey-950'
  | 'caret-red-100'

export type TWillChange =
  | 'will-change-auto'
  | 'will-change-scroll'
  | 'will-change-contents'
  | 'will-change-transform'

export type TAccentColor =
  | 'accent-transparent'
  | 'accent-white'
  | 'accent-white-opacity'
  | 'accent-black'
  | 'accent-blue-100'
  | 'accent-grey-100'
  | 'accent-grey-200'
  | 'accent-grey-300'
  | 'accent-grey-700'
  | 'accent-grey-800'
  | 'accent-grey-900'
  | 'accent-grey-950'
  | 'accent-red-100'
  | 'accent-auto'

export type TScrollPadding =
  | 'scroll-p-0'
  | 'scroll-p-1'
  | 'scroll-p-2'
  | 'scroll-p-3'
  | 'scroll-p-4'
  | 'scroll-p-5'
  | 'scroll-p-6'
  | 'scroll-p-7'
  | 'scroll-p-8'
  | 'scroll-p-9'
  | 'scroll-p-10'
  | 'scroll-p-11'
  | 'scroll-p-12'
  | 'scroll-p-14'
  | 'scroll-p-16'
  | 'scroll-p-17'
  | 'scroll-p-20'
  | 'scroll-p-24'
  | 'scroll-p-28'
  | 'scroll-p-32'
  | 'scroll-p-36'
  | 'scroll-p-40'
  | 'scroll-p-44'
  | 'scroll-p-48'
  | 'scroll-p-52'
  | 'scroll-p-56'
  | 'scroll-p-60'
  | 'scroll-p-64'
  | 'scroll-p-72'
  | 'scroll-p-80'
  | 'scroll-p-96'
  | 'scroll-p-px'
  | 'scroll-p-0.5'
  | 'scroll-p-1.5'
  | 'scroll-p-2.5'
  | 'scroll-p-3.5'
  | 'scroll-py-0'
  | 'scroll-py-1'
  | 'scroll-py-2'
  | 'scroll-py-3'
  | 'scroll-py-4'
  | 'scroll-py-5'
  | 'scroll-py-6'
  | 'scroll-py-7'
  | 'scroll-py-8'
  | 'scroll-py-9'
  | 'scroll-py-10'
  | 'scroll-py-11'
  | 'scroll-py-12'
  | 'scroll-py-14'
  | 'scroll-py-16'
  | 'scroll-py-17'
  | 'scroll-py-20'
  | 'scroll-py-24'
  | 'scroll-py-28'
  | 'scroll-py-32'
  | 'scroll-py-36'
  | 'scroll-py-40'
  | 'scroll-py-44'
  | 'scroll-py-48'
  | 'scroll-py-52'
  | 'scroll-py-56'
  | 'scroll-py-60'
  | 'scroll-py-64'
  | 'scroll-py-72'
  | 'scroll-py-80'
  | 'scroll-py-96'
  | 'scroll-py-px'
  | 'scroll-py-0.5'
  | 'scroll-py-1.5'
  | 'scroll-py-2.5'
  | 'scroll-py-3.5'
  | 'scroll-px-0'
  | 'scroll-px-1'
  | 'scroll-px-2'
  | 'scroll-px-3'
  | 'scroll-px-4'
  | 'scroll-px-5'
  | 'scroll-px-6'
  | 'scroll-px-7'
  | 'scroll-px-8'
  | 'scroll-px-9'
  | 'scroll-px-10'
  | 'scroll-px-11'
  | 'scroll-px-12'
  | 'scroll-px-14'
  | 'scroll-px-16'
  | 'scroll-px-17'
  | 'scroll-px-20'
  | 'scroll-px-24'
  | 'scroll-px-28'
  | 'scroll-px-32'
  | 'scroll-px-36'
  | 'scroll-px-40'
  | 'scroll-px-44'
  | 'scroll-px-48'
  | 'scroll-px-52'
  | 'scroll-px-56'
  | 'scroll-px-60'
  | 'scroll-px-64'
  | 'scroll-px-72'
  | 'scroll-px-80'
  | 'scroll-px-96'
  | 'scroll-px-px'
  | 'scroll-px-0.5'
  | 'scroll-px-1.5'
  | 'scroll-px-2.5'
  | 'scroll-px-3.5'
  | 'scroll-pt-0'
  | 'scroll-pt-1'
  | 'scroll-pt-2'
  | 'scroll-pt-3'
  | 'scroll-pt-4'
  | 'scroll-pt-5'
  | 'scroll-pt-6'
  | 'scroll-pt-7'
  | 'scroll-pt-8'
  | 'scroll-pt-9'
  | 'scroll-pt-10'
  | 'scroll-pt-11'
  | 'scroll-pt-12'
  | 'scroll-pt-14'
  | 'scroll-pt-16'
  | 'scroll-pt-17'
  | 'scroll-pt-20'
  | 'scroll-pt-24'
  | 'scroll-pt-28'
  | 'scroll-pt-32'
  | 'scroll-pt-36'
  | 'scroll-pt-40'
  | 'scroll-pt-44'
  | 'scroll-pt-48'
  | 'scroll-pt-52'
  | 'scroll-pt-56'
  | 'scroll-pt-60'
  | 'scroll-pt-64'
  | 'scroll-pt-72'
  | 'scroll-pt-80'
  | 'scroll-pt-96'
  | 'scroll-pt-px'
  | 'scroll-pt-0.5'
  | 'scroll-pt-1.5'
  | 'scroll-pt-2.5'
  | 'scroll-pt-3.5'
  | 'scroll-pr-0'
  | 'scroll-pr-1'
  | 'scroll-pr-2'
  | 'scroll-pr-3'
  | 'scroll-pr-4'
  | 'scroll-pr-5'
  | 'scroll-pr-6'
  | 'scroll-pr-7'
  | 'scroll-pr-8'
  | 'scroll-pr-9'
  | 'scroll-pr-10'
  | 'scroll-pr-11'
  | 'scroll-pr-12'
  | 'scroll-pr-14'
  | 'scroll-pr-16'
  | 'scroll-pr-17'
  | 'scroll-pr-20'
  | 'scroll-pr-24'
  | 'scroll-pr-28'
  | 'scroll-pr-32'
  | 'scroll-pr-36'
  | 'scroll-pr-40'
  | 'scroll-pr-44'
  | 'scroll-pr-48'
  | 'scroll-pr-52'
  | 'scroll-pr-56'
  | 'scroll-pr-60'
  | 'scroll-pr-64'
  | 'scroll-pr-72'
  | 'scroll-pr-80'
  | 'scroll-pr-96'
  | 'scroll-pr-px'
  | 'scroll-pr-0.5'
  | 'scroll-pr-1.5'
  | 'scroll-pr-2.5'
  | 'scroll-pr-3.5'
  | 'scroll-pb-0'
  | 'scroll-pb-1'
  | 'scroll-pb-2'
  | 'scroll-pb-3'
  | 'scroll-pb-4'
  | 'scroll-pb-5'
  | 'scroll-pb-6'
  | 'scroll-pb-7'
  | 'scroll-pb-8'
  | 'scroll-pb-9'
  | 'scroll-pb-10'
  | 'scroll-pb-11'
  | 'scroll-pb-12'
  | 'scroll-pb-14'
  | 'scroll-pb-16'
  | 'scroll-pb-17'
  | 'scroll-pb-20'
  | 'scroll-pb-24'
  | 'scroll-pb-28'
  | 'scroll-pb-32'
  | 'scroll-pb-36'
  | 'scroll-pb-40'
  | 'scroll-pb-44'
  | 'scroll-pb-48'
  | 'scroll-pb-52'
  | 'scroll-pb-56'
  | 'scroll-pb-60'
  | 'scroll-pb-64'
  | 'scroll-pb-72'
  | 'scroll-pb-80'
  | 'scroll-pb-96'
  | 'scroll-pb-px'
  | 'scroll-pb-0.5'
  | 'scroll-pb-1.5'
  | 'scroll-pb-2.5'
  | 'scroll-pb-3.5'
  | 'scroll-pl-0'
  | 'scroll-pl-1'
  | 'scroll-pl-2'
  | 'scroll-pl-3'
  | 'scroll-pl-4'
  | 'scroll-pl-5'
  | 'scroll-pl-6'
  | 'scroll-pl-7'
  | 'scroll-pl-8'
  | 'scroll-pl-9'
  | 'scroll-pl-10'
  | 'scroll-pl-11'
  | 'scroll-pl-12'
  | 'scroll-pl-14'
  | 'scroll-pl-16'
  | 'scroll-pl-17'
  | 'scroll-pl-20'
  | 'scroll-pl-24'
  | 'scroll-pl-28'
  | 'scroll-pl-32'
  | 'scroll-pl-36'
  | 'scroll-pl-40'
  | 'scroll-pl-44'
  | 'scroll-pl-48'
  | 'scroll-pl-52'
  | 'scroll-pl-56'
  | 'scroll-pl-60'
  | 'scroll-pl-64'
  | 'scroll-pl-72'
  | 'scroll-pl-80'
  | 'scroll-pl-96'
  | 'scroll-pl-px'
  | 'scroll-pl-0.5'
  | 'scroll-pl-1.5'
  | 'scroll-pl-2.5'
  | 'scroll-pl-3.5'

export type TScrollMargin =
  | 'scroll-m-0'
  | 'scroll-m-1'
  | 'scroll-m-2'
  | 'scroll-m-3'
  | 'scroll-m-4'
  | 'scroll-m-5'
  | 'scroll-m-6'
  | 'scroll-m-7'
  | 'scroll-m-8'
  | 'scroll-m-9'
  | 'scroll-m-10'
  | 'scroll-m-11'
  | 'scroll-m-12'
  | 'scroll-m-14'
  | 'scroll-m-16'
  | 'scroll-m-17'
  | 'scroll-m-20'
  | 'scroll-m-24'
  | 'scroll-m-28'
  | 'scroll-m-32'
  | 'scroll-m-36'
  | 'scroll-m-40'
  | 'scroll-m-44'
  | 'scroll-m-48'
  | 'scroll-m-52'
  | 'scroll-m-56'
  | 'scroll-m-60'
  | 'scroll-m-64'
  | 'scroll-m-72'
  | 'scroll-m-80'
  | 'scroll-m-96'
  | 'scroll-m-px'
  | 'scroll-m-0.5'
  | 'scroll-m-1.5'
  | 'scroll-m-2.5'
  | 'scroll-m-3.5'
  | 'scroll-my-0'
  | 'scroll-my-1'
  | 'scroll-my-2'
  | 'scroll-my-3'
  | 'scroll-my-4'
  | 'scroll-my-5'
  | 'scroll-my-6'
  | 'scroll-my-7'
  | 'scroll-my-8'
  | 'scroll-my-9'
  | 'scroll-my-10'
  | 'scroll-my-11'
  | 'scroll-my-12'
  | 'scroll-my-14'
  | 'scroll-my-16'
  | 'scroll-my-17'
  | 'scroll-my-20'
  | 'scroll-my-24'
  | 'scroll-my-28'
  | 'scroll-my-32'
  | 'scroll-my-36'
  | 'scroll-my-40'
  | 'scroll-my-44'
  | 'scroll-my-48'
  | 'scroll-my-52'
  | 'scroll-my-56'
  | 'scroll-my-60'
  | 'scroll-my-64'
  | 'scroll-my-72'
  | 'scroll-my-80'
  | 'scroll-my-96'
  | 'scroll-my-px'
  | 'scroll-my-0.5'
  | 'scroll-my-1.5'
  | 'scroll-my-2.5'
  | 'scroll-my-3.5'
  | 'scroll-mx-0'
  | 'scroll-mx-1'
  | 'scroll-mx-2'
  | 'scroll-mx-3'
  | 'scroll-mx-4'
  | 'scroll-mx-5'
  | 'scroll-mx-6'
  | 'scroll-mx-7'
  | 'scroll-mx-8'
  | 'scroll-mx-9'
  | 'scroll-mx-10'
  | 'scroll-mx-11'
  | 'scroll-mx-12'
  | 'scroll-mx-14'
  | 'scroll-mx-16'
  | 'scroll-mx-17'
  | 'scroll-mx-20'
  | 'scroll-mx-24'
  | 'scroll-mx-28'
  | 'scroll-mx-32'
  | 'scroll-mx-36'
  | 'scroll-mx-40'
  | 'scroll-mx-44'
  | 'scroll-mx-48'
  | 'scroll-mx-52'
  | 'scroll-mx-56'
  | 'scroll-mx-60'
  | 'scroll-mx-64'
  | 'scroll-mx-72'
  | 'scroll-mx-80'
  | 'scroll-mx-96'
  | 'scroll-mx-px'
  | 'scroll-mx-0.5'
  | 'scroll-mx-1.5'
  | 'scroll-mx-2.5'
  | 'scroll-mx-3.5'
  | 'scroll-mt-0'
  | 'scroll-mt-1'
  | 'scroll-mt-2'
  | 'scroll-mt-3'
  | 'scroll-mt-4'
  | 'scroll-mt-5'
  | 'scroll-mt-6'
  | 'scroll-mt-7'
  | 'scroll-mt-8'
  | 'scroll-mt-9'
  | 'scroll-mt-10'
  | 'scroll-mt-11'
  | 'scroll-mt-12'
  | 'scroll-mt-14'
  | 'scroll-mt-16'
  | 'scroll-mt-17'
  | 'scroll-mt-20'
  | 'scroll-mt-24'
  | 'scroll-mt-28'
  | 'scroll-mt-32'
  | 'scroll-mt-36'
  | 'scroll-mt-40'
  | 'scroll-mt-44'
  | 'scroll-mt-48'
  | 'scroll-mt-52'
  | 'scroll-mt-56'
  | 'scroll-mt-60'
  | 'scroll-mt-64'
  | 'scroll-mt-72'
  | 'scroll-mt-80'
  | 'scroll-mt-96'
  | 'scroll-mt-px'
  | 'scroll-mt-0.5'
  | 'scroll-mt-1.5'
  | 'scroll-mt-2.5'
  | 'scroll-mt-3.5'
  | 'scroll-mr-0'
  | 'scroll-mr-1'
  | 'scroll-mr-2'
  | 'scroll-mr-3'
  | 'scroll-mr-4'
  | 'scroll-mr-5'
  | 'scroll-mr-6'
  | 'scroll-mr-7'
  | 'scroll-mr-8'
  | 'scroll-mr-9'
  | 'scroll-mr-10'
  | 'scroll-mr-11'
  | 'scroll-mr-12'
  | 'scroll-mr-14'
  | 'scroll-mr-16'
  | 'scroll-mr-17'
  | 'scroll-mr-20'
  | 'scroll-mr-24'
  | 'scroll-mr-28'
  | 'scroll-mr-32'
  | 'scroll-mr-36'
  | 'scroll-mr-40'
  | 'scroll-mr-44'
  | 'scroll-mr-48'
  | 'scroll-mr-52'
  | 'scroll-mr-56'
  | 'scroll-mr-60'
  | 'scroll-mr-64'
  | 'scroll-mr-72'
  | 'scroll-mr-80'
  | 'scroll-mr-96'
  | 'scroll-mr-px'
  | 'scroll-mr-0.5'
  | 'scroll-mr-1.5'
  | 'scroll-mr-2.5'
  | 'scroll-mr-3.5'
  | 'scroll-mb-0'
  | 'scroll-mb-1'
  | 'scroll-mb-2'
  | 'scroll-mb-3'
  | 'scroll-mb-4'
  | 'scroll-mb-5'
  | 'scroll-mb-6'
  | 'scroll-mb-7'
  | 'scroll-mb-8'
  | 'scroll-mb-9'
  | 'scroll-mb-10'
  | 'scroll-mb-11'
  | 'scroll-mb-12'
  | 'scroll-mb-14'
  | 'scroll-mb-16'
  | 'scroll-mb-17'
  | 'scroll-mb-20'
  | 'scroll-mb-24'
  | 'scroll-mb-28'
  | 'scroll-mb-32'
  | 'scroll-mb-36'
  | 'scroll-mb-40'
  | 'scroll-mb-44'
  | 'scroll-mb-48'
  | 'scroll-mb-52'
  | 'scroll-mb-56'
  | 'scroll-mb-60'
  | 'scroll-mb-64'
  | 'scroll-mb-72'
  | 'scroll-mb-80'
  | 'scroll-mb-96'
  | 'scroll-mb-px'
  | 'scroll-mb-0.5'
  | 'scroll-mb-1.5'
  | 'scroll-mb-2.5'
  | 'scroll-mb-3.5'
  | 'scroll-ml-0'
  | 'scroll-ml-1'
  | 'scroll-ml-2'
  | 'scroll-ml-3'
  | 'scroll-ml-4'
  | 'scroll-ml-5'
  | 'scroll-ml-6'
  | 'scroll-ml-7'
  | 'scroll-ml-8'
  | 'scroll-ml-9'
  | 'scroll-ml-10'
  | 'scroll-ml-11'
  | 'scroll-ml-12'
  | 'scroll-ml-14'
  | 'scroll-ml-16'
  | 'scroll-ml-17'
  | 'scroll-ml-20'
  | 'scroll-ml-24'
  | 'scroll-ml-28'
  | 'scroll-ml-32'
  | 'scroll-ml-36'
  | 'scroll-ml-40'
  | 'scroll-ml-44'
  | 'scroll-ml-48'
  | 'scroll-ml-52'
  | 'scroll-ml-56'
  | 'scroll-ml-60'
  | 'scroll-ml-64'
  | 'scroll-ml-72'
  | 'scroll-ml-80'
  | 'scroll-ml-96'
  | 'scroll-ml-px'
  | 'scroll-ml-0.5'
  | 'scroll-ml-1.5'
  | 'scroll-ml-2.5'
  | 'scroll-ml-3.5'

export type TInteractivity =
  | TAppearance
  | TPointerEvents
  | TResize
  | TUserSelect
  | TScrollSnap
  | TScrollBehavior
  | TTouchAction
  | TCursor
  | TCaretColor
  | TWillChange
  | TAccentColor
  | TScrollPadding
  | TScrollMargin

export type TDisplay =
  | 'block'
  | 'inline-block'
  | 'inline'
  | 'flex'
  | 'inline-flex'
  | 'grid'
  | 'inline-grid'
  | 'table'
  | 'inline-table'
  | 'table-row'
  | 'table-cell'
  | 'contents'
  | 'list-item'
  | 'hidden'

export type TBoxDecorationBreak =
  | 'box-decoration-slice'
  | 'box-decoration-clone'

export type TBoxSizing =
  | 'box-border'
  | 'box-content'

export type TContainer =
  | 'container'

export type TFloat =
  | 'float-right'
  | 'float-left'
  | 'float-none'

export type TClear =
  | 'clear-left'
  | 'clear-right'
  | 'clear-both'
  | 'clear-none'

export type TIsolation =
  | 'isolate'
  | 'isolation-auto'

export type TObjectFit =
  | 'object-contain'
  | 'object-cover'
  | 'object-fill'
  | 'object-none'
  | 'object-scale-down'

export type TOverflow =
  | 'overflow-auto'
  | 'overflow-clip'
  | 'overflow-hidden'
  | 'overflow-visible'
  | 'overflow-scroll'
  | 'overflow-x-auto'
  | 'overflow-y-auto'
  | 'overflow-x-clip'
  | 'overflow-y-clip'
  | 'overflow-x-hidden'
  | 'overflow-y-hidden'
  | 'overflow-x-visible'
  | 'overflow-y-visible'
  | 'overflow-x-scroll'
  | 'overflow-y-scroll'

export type TOverscrollBehavior =
  | 'overscroll-auto'
  | 'overscroll-contain'
  | 'overscroll-none'
  | 'overscroll-y-auto'
  | 'overscroll-y-contain'
  | 'overscroll-y-none'
  | 'overscroll-x-auto'
  | 'overscroll-x-contain'
  | 'overscroll-x-none'

export type TPosition =
  | 'static'
  | 'fixed'
  | 'absolute'
  | 'relative'
  | 'sticky'

export type TVisibility =
  | 'visible'
  | 'invisible'

export type TBreakBefore =
  | 'break-before-auto'
  | 'break-before-avoid'
  | 'break-before-all'
  | 'break-before-avoid-page'
  | 'break-before-page'
  | 'break-before-left'
  | 'break-before-right'
  | 'break-before-column'

export type TBreakInside =
  | 'break-inside-auto'
  | 'break-inside-avoid'
  | 'break-inside-avoid-page'
  | 'break-inside-avoid-column'

export type TBreakAfter =
  | 'break-after-auto'
  | 'break-after-avoid'
  | 'break-after-all'
  | 'break-after-avoid-page'
  | 'break-after-page'
  | 'break-after-left'
  | 'break-after-right'
  | 'break-after-column'

export type TObjectPosition =
  | 'object-bottom'
  | 'object-center'
  | 'object-left'
  | 'object-left-bottom'
  | 'object-left-top'
  | 'object-right'
  | 'object-right-bottom'
  | 'object-right-top'
  | 'object-top'

export type TInset =
  | 'inset-0'
  | 'inset-x-0'
  | 'inset-y-0'
  | 'top-0'
  | 'right-0'
  | 'bottom-0'
  | 'left-0'
  | 'inset-1'
  | 'inset-x-1'
  | 'inset-y-1'
  | 'top-1'
  | 'right-1'
  | 'bottom-1'
  | 'left-1'
  | 'inset-2'
  | 'inset-x-2'
  | 'inset-y-2'
  | 'top-2'
  | 'right-2'
  | 'bottom-2'
  | 'left-2'
  | 'inset-3'
  | 'inset-x-3'
  | 'inset-y-3'
  | 'top-3'
  | 'right-3'
  | 'bottom-3'
  | 'left-3'
  | 'inset-4'
  | 'inset-x-4'
  | 'inset-y-4'
  | 'top-4'
  | 'right-4'
  | 'bottom-4'
  | 'left-4'
  | 'inset-5'
  | 'inset-x-5'
  | 'inset-y-5'
  | 'top-5'
  | 'right-5'
  | 'bottom-5'
  | 'left-5'
  | 'inset-6'
  | 'inset-x-6'
  | 'inset-y-6'
  | 'top-6'
  | 'right-6'
  | 'bottom-6'
  | 'left-6'
  | 'inset-7'
  | 'inset-x-7'
  | 'inset-y-7'
  | 'top-7'
  | 'right-7'
  | 'bottom-7'
  | 'left-7'
  | 'inset-8'
  | 'inset-x-8'
  | 'inset-y-8'
  | 'top-8'
  | 'right-8'
  | 'bottom-8'
  | 'left-8'
  | 'inset-9'
  | 'inset-x-9'
  | 'inset-y-9'
  | 'top-9'
  | 'right-9'
  | 'bottom-9'
  | 'left-9'
  | 'inset-10'
  | 'inset-x-10'
  | 'inset-y-10'
  | 'top-10'
  | 'right-10'
  | 'bottom-10'
  | 'left-10'
  | 'inset-11'
  | 'inset-x-11'
  | 'inset-y-11'
  | 'top-11'
  | 'right-11'
  | 'bottom-11'
  | 'left-11'
  | 'inset-12'
  | 'inset-x-12'
  | 'inset-y-12'
  | 'top-12'
  | 'right-12'
  | 'bottom-12'
  | 'left-12'
  | 'inset-14'
  | 'inset-x-14'
  | 'inset-y-14'
  | 'top-14'
  | 'right-14'
  | 'bottom-14'
  | 'left-14'
  | 'inset-16'
  | 'inset-x-16'
  | 'inset-y-16'
  | 'top-16'
  | 'right-16'
  | 'bottom-16'
  | 'left-16'
  | 'inset-17'
  | 'inset-x-17'
  | 'inset-y-17'
  | 'top-17'
  | 'right-17'
  | 'bottom-17'
  | 'left-17'
  | 'inset-20'
  | 'inset-x-20'
  | 'inset-y-20'
  | 'top-20'
  | 'right-20'
  | 'bottom-20'
  | 'left-20'
  | 'inset-24'
  | 'inset-x-24'
  | 'inset-y-24'
  | 'top-24'
  | 'right-24'
  | 'bottom-24'
  | 'left-24'
  | 'inset-28'
  | 'inset-x-28'
  | 'inset-y-28'
  | 'top-28'
  | 'right-28'
  | 'bottom-28'
  | 'left-28'
  | 'inset-32'
  | 'inset-x-32'
  | 'inset-y-32'
  | 'top-32'
  | 'right-32'
  | 'bottom-32'
  | 'left-32'
  | 'inset-36'
  | 'inset-x-36'
  | 'inset-y-36'
  | 'top-36'
  | 'right-36'
  | 'bottom-36'
  | 'left-36'
  | 'inset-40'
  | 'inset-x-40'
  | 'inset-y-40'
  | 'top-40'
  | 'right-40'
  | 'bottom-40'
  | 'left-40'
  | 'inset-44'
  | 'inset-x-44'
  | 'inset-y-44'
  | 'top-44'
  | 'right-44'
  | 'bottom-44'
  | 'left-44'
  | 'inset-48'
  | 'inset-x-48'
  | 'inset-y-48'
  | 'top-48'
  | 'right-48'
  | 'bottom-48'
  | 'left-48'
  | 'inset-52'
  | 'inset-x-52'
  | 'inset-y-52'
  | 'top-52'
  | 'right-52'
  | 'bottom-52'
  | 'left-52'
  | 'inset-56'
  | 'inset-x-56'
  | 'inset-y-56'
  | 'top-56'
  | 'right-56'
  | 'bottom-56'
  | 'left-56'
  | 'inset-60'
  | 'inset-x-60'
  | 'inset-y-60'
  | 'top-60'
  | 'right-60'
  | 'bottom-60'
  | 'left-60'
  | 'inset-64'
  | 'inset-x-64'
  | 'inset-y-64'
  | 'top-64'
  | 'right-64'
  | 'bottom-64'
  | 'left-64'
  | 'inset-72'
  | 'inset-x-72'
  | 'inset-y-72'
  | 'top-72'
  | 'right-72'
  | 'bottom-72'
  | 'left-72'
  | 'inset-80'
  | 'inset-x-80'
  | 'inset-y-80'
  | 'top-80'
  | 'right-80'
  | 'bottom-80'
  | 'left-80'
  | 'inset-96'
  | 'inset-x-96'
  | 'inset-y-96'
  | 'top-96'
  | 'right-96'
  | 'bottom-96'
  | 'left-96'
  | 'inset-auto'
  | 'inset-x-auto'
  | 'inset-y-auto'
  | 'top-auto'
  | 'right-auto'
  | 'bottom-auto'
  | 'left-auto'
  | 'inset-px'
  | 'inset-x-px'
  | 'inset-y-px'
  | 'top-px'
  | 'right-px'
  | 'bottom-px'
  | 'left-px'
  | 'inset-0.5'
  | 'inset-x-0.5'
  | 'inset-y-0.5'
  | 'top-0.5'
  | 'right-0.5'
  | 'bottom-0.5'
  | 'left-0.5'
  | 'inset-1.5'
  | 'inset-x-1.5'
  | 'inset-y-1.5'
  | 'top-1.5'
  | 'right-1.5'
  | 'bottom-1.5'
  | 'left-1.5'
  | 'inset-2.5'
  | 'inset-x-2.5'
  | 'inset-y-2.5'
  | 'top-2.5'
  | 'right-2.5'
  | 'bottom-2.5'
  | 'left-2.5'
  | 'inset-3.5'
  | 'inset-x-3.5'
  | 'inset-y-3.5'
  | 'top-3.5'
  | 'right-3.5'
  | 'bottom-3.5'
  | 'left-3.5'
  | 'inset-1/2'
  | 'inset-x-1/2'
  | 'inset-y-1/2'
  | 'top-1/2'
  | 'right-1/2'
  | 'bottom-1/2'
  | 'left-1/2'
  | 'inset-1/3'
  | 'inset-x-1/3'
  | 'inset-y-1/3'
  | 'top-1/3'
  | 'right-1/3'
  | 'bottom-1/3'
  | 'left-1/3'
  | 'inset-2/3'
  | 'inset-x-2/3'
  | 'inset-y-2/3'
  | 'top-2/3'
  | 'right-2/3'
  | 'bottom-2/3'
  | 'left-2/3'
  | 'inset-1/4'
  | 'inset-x-1/4'
  | 'inset-y-1/4'
  | 'top-1/4'
  | 'right-1/4'
  | 'bottom-1/4'
  | 'left-1/4'
  | 'inset-2/4'
  | 'inset-x-2/4'
  | 'inset-y-2/4'
  | 'top-2/4'
  | 'right-2/4'
  | 'bottom-2/4'
  | 'left-2/4'
  | 'inset-3/4'
  | 'inset-x-3/4'
  | 'inset-y-3/4'
  | 'top-3/4'
  | 'right-3/4'
  | 'bottom-3/4'
  | 'left-3/4'
  | 'inset-full'
  | 'inset-x-full'
  | 'inset-y-full'
  | 'top-full'
  | 'right-full'
  | 'bottom-full'
  | 'left-full'

export type TZIndex =
  | 'z-0'
  | 'z-10'
  | 'z-20'
  | 'z-30'
  | 'z-40'
  | 'z-50'
  | 'z-auto'

export type TAspectRatio =
  | 'aspect-auto'
  | 'aspect-square'
  | 'aspect-video'

export type TColumns =
  | 'columns-1'
  | 'columns-2'
  | 'columns-3'
  | 'columns-4'
  | 'columns-5'
  | 'columns-6'
  | 'columns-7'
  | 'columns-8'
  | 'columns-9'
  | 'columns-10'
  | 'columns-11'
  | 'columns-12'
  | 'columns-auto'
  | 'columns-3xs'
  | 'columns-2xs'
  | 'columns-xs'
  | 'columns-sm'
  | 'columns-md'
  | 'columns-lg'
  | 'columns-xl'
  | 'columns-2xl'
  | 'columns-3xl'
  | 'columns-4xl'
  | 'columns-5xl'
  | 'columns-6xl'
  | 'columns-7xl'

export type TLayout =
  | TDisplay
  | TBoxDecorationBreak
  | TBoxSizing
  | TContainer
  | TFloat
  | TClear
  | TIsolation
  | TObjectFit
  | TOverflow
  | TOverscrollBehavior
  | TPosition
  | TVisibility
  | TBreakBefore
  | TBreakInside
  | TBreakAfter
  | TObjectPosition
  | TInset
  | TZIndex
  | TAspectRatio
  | TColumns

export type TWidth =
  | 'w-0'
  | 'w-1'
  | 'w-2'
  | 'w-3'
  | 'w-4'
  | 'w-5'
  | 'w-6'
  | 'w-7'
  | 'w-8'
  | 'w-9'
  | 'w-10'
  | 'w-11'
  | 'w-12'
  | 'w-14'
  | 'w-16'
  | 'w-17'
  | 'w-20'
  | 'w-24'
  | 'w-26'
  | 'w-28'
  | 'w-32'
  | 'w-36'
  | 'w-40'
  | 'w-44'
  | 'w-48'
  | 'w-52'
  | 'w-56'
  | 'w-60'
  | 'w-64'
  | 'w-72'
  | 'w-80'
  | 'w-96'
  | 'w-auto'
  | 'w-px'
  | 'w-0.5'
  | 'w-1.5'
  | 'w-2.5'
  | 'w-3.5'
  | 'w-1/2'
  | 'w-1/3'
  | 'w-2/3'
  | 'w-1/4'
  | 'w-2/4'
  | 'w-3/4'
  | 'w-1/5'
  | 'w-2/5'
  | 'w-3/5'
  | 'w-4/5'
  | 'w-1/6'
  | 'w-2/6'
  | 'w-3/6'
  | 'w-4/6'
  | 'w-5/6'
  | 'w-1/12'
  | 'w-2/12'
  | 'w-3/12'
  | 'w-4/12'
  | 'w-5/12'
  | 'w-6/12'
  | 'w-7/12'
  | 'w-8/12'
  | 'w-9/12'
  | 'w-10/12'
  | 'w-11/12'
  | 'w-full'
  | 'w-screen'
  | 'w-min'
  | 'w-max'
  | 'w-fit'

export type TMinWidth =
  | 'min-w-0'
  | 'min-w-full'
  | 'min-w-min'
  | 'min-w-max'
  | 'min-w-fit'

export type TMaxWidth =
  | 'max-w-0'
  | 'max-w-none'
  | 'max-w-xs'
  | 'max-w-sm'
  | 'max-w-md'
  | 'max-w-lg'
  | 'max-w-xl'
  | 'max-w-2xl'
  | 'max-w-3xl'
  | 'max-w-4xl'
  | 'max-w-5xl'
  | 'max-w-6xl'
  | 'max-w-7xl'
  | 'max-w-full'
  | 'max-w-min'
  | 'max-w-max'
  | 'max-w-fit'
  | 'max-w-prose'
  | 'max-w-screen-sm'
  | 'max-w-screen-md'
  | 'max-w-screen-lg'
  | 'max-w-screen-xl'
  | 'max-w-screen-2xl'

export type THeight =
  | 'h-0'
  | 'h-1'
  | 'h-2'
  | 'h-3'
  | 'h-4'
  | 'h-5'
  | 'h-6'
  | 'h-7'
  | 'h-8'
  | 'h-9'
  | 'h-10'
  | 'h-11'
  | 'h-12'
  | 'h-14'
  | 'h-16'
  | 'h-17'
  | 'h-20'
  | 'h-24'
  | 'h-28'
  | 'h-32'
  | 'h-36'
  | 'h-40'
  | 'h-44'
  | 'h-48'
  | 'h-52'
  | 'h-56'
  | 'h-60'
  | 'h-64'
  | 'h-72'
  | 'h-80'
  | 'h-96'
  | 'h-auto'
  | 'h-px'
  | 'h-0.5'
  | 'h-1.5'
  | 'h-2.5'
  | 'h-3.5'
  | 'h-1/2'
  | 'h-1/3'
  | 'h-2/3'
  | 'h-1/4'
  | 'h-2/4'
  | 'h-3/4'
  | 'h-1/5'
  | 'h-2/5'
  | 'h-3/5'
  | 'h-4/5'
  | 'h-1/6'
  | 'h-2/6'
  | 'h-3/6'
  | 'h-4/6'
  | 'h-5/6'
  | 'h-full'
  | 'h-screen'
  | 'h-min'
  | 'h-max'
  | 'h-fit'

export type TMinHeight =
  | 'min-h-0'
  | 'min-h-full'
  | 'min-h-screen'
  | 'min-h-min'
  | 'min-h-max'
  | 'min-h-fit'

export type TMaxHeight =
  | 'max-h-0'
  | 'max-h-1'
  | 'max-h-2'
  | 'max-h-3'
  | 'max-h-4'
  | 'max-h-5'
  | 'max-h-6'
  | 'max-h-7'
  | 'max-h-8'
  | 'max-h-9'
  | 'max-h-10'
  | 'max-h-11'
  | 'max-h-12'
  | 'max-h-14'
  | 'max-h-16'
  | 'max-h-17'
  | 'max-h-20'
  | 'max-h-24'
  | 'max-h-28'
  | 'max-h-32'
  | 'max-h-36'
  | 'max-h-40'
  | 'max-h-44'
  | 'max-h-48'
  | 'max-h-52'
  | 'max-h-56'
  | 'max-h-60'
  | 'max-h-64'
  | 'max-h-72'
  | 'max-h-80'
  | 'max-h-96'
  | 'max-h-px'
  | 'max-h-0.5'
  | 'max-h-1.5'
  | 'max-h-2.5'
  | 'max-h-3.5'
  | 'max-h-full'
  | 'max-h-screen'
  | 'max-h-min'
  | 'max-h-max'
  | 'max-h-fit'

export type TSizing =
  | TWidth
  | TMinWidth
  | TMaxWidth
  | THeight
  | TMinHeight
  | TMaxHeight

export type TFill =
  | 'fill-transparent'
  | 'fill-white'
  | 'fill-white-opacity'
  | 'fill-black'
  | 'fill-blue-100'
  | 'fill-grey-100'
  | 'fill-grey-200'
  | 'fill-grey-300'
  | 'fill-grey-700'
  | 'fill-grey-800'
  | 'fill-grey-900'
  | 'fill-grey-950'
  | 'fill-red-100'

export type TStroke =
  | 'stroke-transparent'
  | 'stroke-white'
  | 'stroke-white-opacity'
  | 'stroke-black'
  | 'stroke-blue-100'
  | 'stroke-grey-100'
  | 'stroke-grey-200'
  | 'stroke-grey-300'
  | 'stroke-grey-700'
  | 'stroke-grey-800'
  | 'stroke-grey-900'
  | 'stroke-grey-950'
  | 'stroke-red-100'

export type TStrokeWidth =
  | 'stroke-0'
  | 'stroke-1'
  | 'stroke-2'

export type TSVG =
  | TFill
  | TStroke
  | TStrokeWidth

export type THardwareAcceleration =
  | 'transform-gpu'

export type TScale =
  | 'scale-0'
  | 'scale-50'
  | 'scale-75'
  | 'scale-90'
  | 'scale-95'
  | 'scale-100'
  | 'scale-105'
  | 'scale-110'
  | 'scale-125'
  | 'scale-150'
  | 'scale-x-0'
  | 'scale-x-50'
  | 'scale-x-75'
  | 'scale-x-90'
  | 'scale-x-95'
  | 'scale-x-100'
  | 'scale-x-105'
  | 'scale-x-110'
  | 'scale-x-125'
  | 'scale-x-150'
  | 'scale-y-0'
  | 'scale-y-50'
  | 'scale-y-75'
  | 'scale-y-90'
  | 'scale-y-95'
  | 'scale-y-100'
  | 'scale-y-105'
  | 'scale-y-110'
  | 'scale-y-125'
  | 'scale-y-150'

export type TRotate =
  | 'rotate-0'
  | 'rotate-1'
  | 'rotate-2'
  | 'rotate-3'
  | 'rotate-6'
  | 'rotate-12'
  | 'rotate-45'
  | 'rotate-90'
  | 'rotate-180'

export type TTranslate =
  | 'translate-x-0'
  | 'translate-x-1'
  | 'translate-x-2'
  | 'translate-x-3'
  | 'translate-x-4'
  | 'translate-x-5'
  | 'translate-x-6'
  | 'translate-x-7'
  | 'translate-x-8'
  | 'translate-x-9'
  | 'translate-x-10'
  | 'translate-x-11'
  | 'translate-x-12'
  | 'translate-x-14'
  | 'translate-x-16'
  | 'translate-x-17'
  | 'translate-x-20'
  | 'translate-x-24'
  | 'translate-x-28'
  | 'translate-x-32'
  | 'translate-x-36'
  | 'translate-x-40'
  | 'translate-x-44'
  | 'translate-x-48'
  | 'translate-x-52'
  | 'translate-x-56'
  | 'translate-x-60'
  | 'translate-x-64'
  | 'translate-x-72'
  | 'translate-x-80'
  | 'translate-x-96'
  | 'translate-x-px'
  | 'translate-x-0.5'
  | 'translate-x-1.5'
  | 'translate-x-2.5'
  | 'translate-x-3.5'
  | 'translate-x-1/2'
  | 'translate-x-1/3'
  | 'translate-x-2/3'
  | 'translate-x-1/4'
  | 'translate-x-2/4'
  | 'translate-x-3/4'
  | 'translate-x-full'
  | 'translate-y-0'
  | 'translate-y-1'
  | 'translate-y-2'
  | 'translate-y-3'
  | 'translate-y-4'
  | 'translate-y-5'
  | 'translate-y-6'
  | 'translate-y-7'
  | 'translate-y-8'
  | 'translate-y-9'
  | 'translate-y-10'
  | 'translate-y-11'
  | 'translate-y-12'
  | 'translate-y-14'
  | 'translate-y-16'
  | 'translate-y-17'
  | 'translate-y-20'
  | 'translate-y-24'
  | 'translate-y-28'
  | 'translate-y-32'
  | 'translate-y-36'
  | 'translate-y-40'
  | 'translate-y-44'
  | 'translate-y-48'
  | 'translate-y-52'
  | 'translate-y-56'
  | 'translate-y-60'
  | 'translate-y-64'
  | 'translate-y-72'
  | 'translate-y-80'
  | 'translate-y-96'
  | 'translate-y-px'
  | 'translate-y-0.5'
  | 'translate-y-1.5'
  | 'translate-y-2.5'
  | 'translate-y-3.5'
  | 'translate-y-1/2'
  | 'translate-y-1/3'
  | 'translate-y-2/3'
  | 'translate-y-1/4'
  | 'translate-y-2/4'
  | 'translate-y-3/4'
  | 'translate-y-full'

export type TSkew =
  | 'skew-x-0'
  | 'skew-x-1'
  | 'skew-x-2'
  | 'skew-x-3'
  | 'skew-x-6'
  | 'skew-x-12'
  | 'skew-y-0'
  | 'skew-y-1'
  | 'skew-y-2'
  | 'skew-y-3'
  | 'skew-y-6'
  | 'skew-y-12'

export type TTransformOrigin =
  | 'origin-center'
  | 'origin-top'
  | 'origin-top-right'
  | 'origin-right'
  | 'origin-bottom-right'
  | 'origin-bottom'
  | 'origin-bottom-left'
  | 'origin-left'
  | 'origin-top-left'

export type TTransforms =
  | THardwareAcceleration
  | TScale
  | TRotate
  | TTranslate
  | TSkew
  | TTransformOrigin

export type TFontSmoothing =
  | 'antialiased'
  | 'subpixel-antialiased'

export type TFontStyle =
  | 'italic'
  | 'non-italic'

export type TFontVariantNumeric =
  | 'normal-nums'
  | 'ordinal'
  | 'slashed-zero'
  | 'lining-nums'
  | 'oldstyle-nums'
  | 'proportional-nums'
  | 'tabular-nums'
  | 'diagonal-fractions'
  | 'stacked-fractions'

export type TListStylePosition =
  | 'list-inside'
  | 'list-outside'

export type TTextAlign =
  | 'text-left'
  | 'text-center'
  | 'text-right'
  | 'text-justify'

export type TTextDecoration =
  | 'underline'
  | 'line-through'
  | 'no-underline'

export type TTextTransform =
  | 'uppercase'
  | 'lowercase'
  | 'capitalize'
  | 'normal-case'

export type TTextOverflow =
  | 'truncate'
  | 'text-ellipsis'
  | 'text-clip'

export type TVerticalAlign =
  | 'align-baseline'
  | 'align-top'
  | 'align-middle'
  | 'align-bottom'
  | 'align-text-top'
  | 'align-text-bottom'
  | 'align-sub'
  | 'align-super'

export type TWhitespace =
  | 'whitespace-normal'
  | 'whitespace-nowrap'
  | 'whitespace-pre'
  | 'whitespace-pre-line'
  | 'whitespace-pre-wrap'

export type TWordBreak =
  | 'break-normal'
  | 'break-words'
  | 'break-all'

export type TTextDecorationStyle =
  | 'decoration-solid'
  | 'decoration-double'
  | 'decoration-dotted'
  | 'decoration-dashed'
  | 'decoration-wavy'

export type TFontFamily =
  | 'font-sans'

export type TFontSize =
  | 'text-xs'
  | 'text-sm'
  | 'text-base'
  | 'text-lg'
  | 'text-xl'
  | 'text-2xl'
  | 'text-3xl'
  | 'text-4xl'
  | 'text-5xl'
  | 'text-6xl'
  | 'text-7xl'
  | 'text-8xl'
  | 'text-9xl'

export type TFontWeight =
  | 'font-thin'
  | 'font-extralight'
  | 'font-light'
  | 'font-normal'
  | 'font-medium'
  | 'font-semibold'
  | 'font-bold'
  | 'font-extrabold'
  | 'font-black'

export type TLetterSpacing =
  | 'tracking-tighter'
  | 'tracking-tight'
  | 'tracking-normal'
  | 'tracking-wide'
  | 'tracking-wider'
  | 'tracking-widest'

export type TLineHeight =
  | 'leading-3'
  | 'leading-4'
  | 'leading-5'
  | 'leading-6'
  | 'leading-7'
  | 'leading-8'
  | 'leading-9'
  | 'leading-10'
  | 'leading-none'
  | 'leading-tight'
  | 'leading-snug'
  | 'leading-normal'
  | 'leading-relaxed'
  | 'leading-loose'

export type TListStyleType =
  | 'list-none'
  | 'list-disc'
  | 'list-decimal'

export type TPlaceholderColor =
  | 'placeholder-transparent'
  | 'placeholder-white'
  | 'placeholder-white-opacity'
  | 'placeholder-black'
  | 'placeholder-blue-100'
  | 'placeholder-grey-100'
  | 'placeholder-grey-200'
  | 'placeholder-grey-300'
  | 'placeholder-grey-700'
  | 'placeholder-grey-800'
  | 'placeholder-grey-900'
  | 'placeholder-grey-950'
  | 'placeholder-red-100'

export type TPlaceholderOpacity =
  | 'placeholder-opacity-0'
  | 'placeholder-opacity-5'
  | 'placeholder-opacity-10'
  | 'placeholder-opacity-20'
  | 'placeholder-opacity-25'
  | 'placeholder-opacity-30'
  | 'placeholder-opacity-40'
  | 'placeholder-opacity-50'
  | 'placeholder-opacity-60'
  | 'placeholder-opacity-70'
  | 'placeholder-opacity-75'
  | 'placeholder-opacity-80'
  | 'placeholder-opacity-90'
  | 'placeholder-opacity-95'
  | 'placeholder-opacity-100'

export type TTextColor =
  | 'text-transparent'
  | 'text-white'
  | 'text-white-opacity'
  | 'text-black'
  | 'text-blue-100'
  | 'text-grey-100'
  | 'text-grey-200'
  | 'text-grey-300'
  | 'text-grey-700'
  | 'text-grey-800'
  | 'text-grey-900'
  | 'text-grey-950'
  | 'text-red-100'

export type TTextOpacity =
  | 'text-opacity-0'
  | 'text-opacity-5'
  | 'text-opacity-10'
  | 'text-opacity-20'
  | 'text-opacity-25'
  | 'text-opacity-30'
  | 'text-opacity-40'
  | 'text-opacity-50'
  | 'text-opacity-60'
  | 'text-opacity-70'
  | 'text-opacity-75'
  | 'text-opacity-80'
  | 'text-opacity-90'
  | 'text-opacity-95'
  | 'text-opacity-100'

export type TContent =
  | 'content-none'

export type TTextIndent =
  | 'indent-0'
  | 'indent-1'
  | 'indent-2'
  | 'indent-3'
  | 'indent-4'
  | 'indent-5'
  | 'indent-6'
  | 'indent-7'
  | 'indent-8'
  | 'indent-9'
  | 'indent-10'
  | 'indent-11'
  | 'indent-12'
  | 'indent-14'
  | 'indent-16'
  | 'indent-17'
  | 'indent-20'
  | 'indent-24'
  | 'indent-28'
  | 'indent-32'
  | 'indent-36'
  | 'indent-40'
  | 'indent-44'
  | 'indent-48'
  | 'indent-52'
  | 'indent-56'
  | 'indent-60'
  | 'indent-64'
  | 'indent-72'
  | 'indent-80'
  | 'indent-96'
  | 'indent-px'
  | 'indent-0.5'
  | 'indent-1.5'
  | 'indent-2.5'
  | 'indent-3.5'

export type TTextDecorationColor =
  | 'decoration-transparent'
  | 'decoration-white'
  | 'decoration-white-opacity'
  | 'decoration-black'
  | 'decoration-blue-100'
  | 'decoration-grey-100'
  | 'decoration-grey-200'
  | 'decoration-grey-300'
  | 'decoration-grey-700'
  | 'decoration-grey-800'
  | 'decoration-grey-900'
  | 'decoration-grey-950'
  | 'decoration-red-100'

export type TTextDecorationThickness =
  | 'decoration-0'
  | 'decoration-1'
  | 'decoration-2'
  | 'decoration-4'
  | 'decoration-8'
  | 'decoration-auto'
  | 'decoration-from-font'

export type TTextUnderlineOffset =
  | 'underline-offset-0'
  | 'underline-offset-1'
  | 'underline-offset-2'
  | 'underline-offset-4'
  | 'underline-offset-8'
  | 'underline-offset-auto'

export type TTypography =
  | TFontSmoothing
  | TFontStyle
  | TFontVariantNumeric
  | TListStylePosition
  | TTextAlign
  | TTextDecoration
  | TTextTransform
  | TTextOverflow
  | TVerticalAlign
  | TWhitespace
  | TWordBreak
  | TTextDecorationStyle
  | TFontFamily
  | TFontSize
  | TFontWeight
  | TLetterSpacing
  | TLineHeight
  | TListStyleType
  | TPlaceholderColor
  | TPlaceholderOpacity
  | TTextColor
  | TTextOpacity
  | TContent
  | TTextIndent
  | TTextDecorationColor
  | TTextDecorationThickness
  | TTextUnderlineOffset


export type TPseudoClassVariants =
  | 'motion-safe:'
  | 'motion-reduce:'
  | 'first:'
  | 'last:'
  | 'odd:'
  | 'even:'
  | 'visited:'
  | 'checked:'
  | 'group:'
  | 'group-hover:'
  | 'group-focus:'
  | 'focus-within:'
  | 'hover:'
  | 'focus:'
  | 'focus-visible:'
  | 'active:'
  | 'disabled:'
  | 'only:'
  | 'first-of-type:'
  | 'last-of-type:'
  | 'only-of-type:'
  | 'target:'
  | 'default:'
  | 'indeterminate:'
  | 'placeholder-shown:'
  | 'autofill:'
  | 'required:'
  | 'valid:'
  | 'invalid:'
  | 'in-range:'
  | 'out-of-range:'
  | 'peer:'
  | 'peer-hover:'
  | 'peer-checked:'
  | 'peer-focus:'
  | 'selection:'
  | 'marker:'
  | 'before:'
  | 'after:'
  | 'portrait:'
  | 'landscape:'
  | 'open:'
  | 'file:'
  | 'placeholder:'
  | 'print:'
  | 'ltr:'
  | 'rtl:'
  | 'sm:'
  | 'md:'
  | 'lg:'
  | 'xl:'
  | '2xl:'

//////////// Utility Function generic type

type TUtilityFunction<T extends string> = (
  ...args: Array<
    | T
    | `!${T}`
    | `${TPseudoClassVariants}${T}`
    | `${TPseudoClassVariants}!${T}`
    | null
    | undefined
    | {[key in T | `${TPseudoClassVariants}${T}` | `!${T}` | `${TPseudoClassVariants}!${T}` | TTailwindString]?: boolean}
    | TTailwindString
  >
) => TTailwindString;

//////////// Accessibility Utility functions

export const screenReaders: TUtilityFunction<TScreenReaders> = classnamesLib as any

//////////// Backgrounds Utility functions

export const backgroundAttachment: TUtilityFunction<TBackgroundAttachment> = classnamesLib as any
export const backgroundClip: TUtilityFunction<TBackgroundClip> = classnamesLib as any
export const backgroundOrigin: TUtilityFunction<TBackgroundOrigin> = classnamesLib as any
export const backgroundRepeat: TUtilityFunction<TBackgroundRepeat> = classnamesLib as any
export const backgroundOpacity: TUtilityFunction<TBackgroundOpacity> = classnamesLib as any
export const backgroundColor: TUtilityFunction<TBackgroundColor> = classnamesLib as any
export const backgroundPosition: TUtilityFunction<TBackgroundPosition> = classnamesLib as any
export const backgroundSize: TUtilityFunction<TBackgroundSize> = classnamesLib as any
export const backgroundImage: TUtilityFunction<TBackgroundImage> = classnamesLib as any
export const gradientColorStops: TUtilityFunction<TGradientColorStops> = classnamesLib as any

//////////// Borders Utility functions

export const borderStyle: TUtilityFunction<TBorderStyle> = classnamesLib as any
export const divideStyle: TUtilityFunction<TDivideStyle> = classnamesLib as any
export const outlineStyle: TUtilityFunction<TOutlineStyle> = classnamesLib as any
export const borderColor: TUtilityFunction<TBorderColor> = classnamesLib as any
export const borderOpacity: TUtilityFunction<TBorderOpacity> = classnamesLib as any
export const borderRadius: TUtilityFunction<TBorderRadius> = classnamesLib as any
export const borderWidth: TUtilityFunction<TBorderWidth> = classnamesLib as any
export const divideColor: TUtilityFunction<TDivideColor> = classnamesLib as any
export const divideOpacity: TUtilityFunction<TDivideOpacity> = classnamesLib as any
export const divideWidth: TUtilityFunction<TDivideWidth> = classnamesLib as any
export const ringColor: TUtilityFunction<TRingColor> = classnamesLib as any
export const ringWidth: TUtilityFunction<TRingWidth> = classnamesLib as any
export const ringOpacity: TUtilityFunction<TRingOpacity> = classnamesLib as any
export const ringOffsetColor: TUtilityFunction<TRingOffsetColor> = classnamesLib as any
export const ringOffsetWidth: TUtilityFunction<TRingOffsetWidth> = classnamesLib as any
export const outlineOffset: TUtilityFunction<TOutlineOffset> = classnamesLib as any
export const outlineWidth: TUtilityFunction<TOutlineWidth> = classnamesLib as any
export const outlineColor: TUtilityFunction<TOutlineColor> = classnamesLib as any

//////////// Tables Utility functions

export const borderCollapse: TUtilityFunction<TBorderCollapse> = classnamesLib as any
export const tableLayout: TUtilityFunction<TTableLayout> = classnamesLib as any

//////////// Effects Utility functions

export const mixBlendMode: TUtilityFunction<TMixBlendMode> = classnamesLib as any
export const backgroundBlendMode: TUtilityFunction<TBackgroundBlendMode> = classnamesLib as any
export const boxShadow: TUtilityFunction<TBoxShadow> = classnamesLib as any
export const boxShadowColor: TUtilityFunction<TBoxShadowColor> = classnamesLib as any
export const opacity: TUtilityFunction<TOpacity> = classnamesLib as any

//////////// TransitionsAndAnimations Utility functions

export const transitionProperty: TUtilityFunction<TTransitionProperty> = classnamesLib as any
export const transitionDuration: TUtilityFunction<TTransitionDuration> = classnamesLib as any
export const transitionTimingFunction: TUtilityFunction<TTransitionTimingFunction> = classnamesLib as any
export const transitionDelay: TUtilityFunction<TTransitionDelay> = classnamesLib as any
export const animation: TUtilityFunction<TAnimation> = classnamesLib as any

//////////// Filters Utility functions

export const filter: TUtilityFunction<TFilter> = classnamesLib as any
export const backdropFilter: TUtilityFunction<TBackdropFilter> = classnamesLib as any
export const blur: TUtilityFunction<TBlur> = classnamesLib as any
export const brightness: TUtilityFunction<TBrightness> = classnamesLib as any
export const contrast: TUtilityFunction<TContrast> = classnamesLib as any
export const dropShadow: TUtilityFunction<TDropShadow> = classnamesLib as any
export const grayscale: TUtilityFunction<TGrayscale> = classnamesLib as any
export const hueRotate: TUtilityFunction<THueRotate> = classnamesLib as any
export const invert: TUtilityFunction<TInvert> = classnamesLib as any
export const saturate: TUtilityFunction<TSaturate> = classnamesLib as any
export const sepia: TUtilityFunction<TSepia> = classnamesLib as any
export const backdropBlur: TUtilityFunction<TBackdropBlur> = classnamesLib as any
export const backdropBrightness: TUtilityFunction<TBackdropBrightness> = classnamesLib as any
export const backdropContrast: TUtilityFunction<TBackdropContrast> = classnamesLib as any
export const backdropGrayscale: TUtilityFunction<TBackdropGrayscale> = classnamesLib as any
export const backdropHueRotate: TUtilityFunction<TBackdropHueRotate> = classnamesLib as any
export const backdropInvert: TUtilityFunction<TBackdropInvert> = classnamesLib as any
export const backdropOpacity: TUtilityFunction<TBackdropOpacity> = classnamesLib as any
export const backdropSaturate: TUtilityFunction<TBackdropSaturate> = classnamesLib as any
export const backdropSepia: TUtilityFunction<TBackdropSepia> = classnamesLib as any

//////////// FlexBox Utility functions

export const flexDirection: TUtilityFunction<TFlexDirection> = classnamesLib as any
export const flexWrap: TUtilityFunction<TFlexWrap> = classnamesLib as any
export const alignItems: TUtilityFunction<TAlignItems> = classnamesLib as any
export const alignContent: TUtilityFunction<TAlignContent> = classnamesLib as any
export const alignSelf: TUtilityFunction<TAlignSelf> = classnamesLib as any
export const placeContent: TUtilityFunction<TPlaceContent> = classnamesLib as any
export const placeItems: TUtilityFunction<TPlaceItems> = classnamesLib as any
export const placeSelf: TUtilityFunction<TPlaceSelf> = classnamesLib as any
export const justifyContent: TUtilityFunction<TJustifyContent> = classnamesLib as any
export const justifyItems: TUtilityFunction<TJustifyItems> = classnamesLib as any
export const justifySelf: TUtilityFunction<TJustifySelf> = classnamesLib as any
export const flex: TUtilityFunction<TFlex> = classnamesLib as any
export const flexBasis: TUtilityFunction<TFlexBasis> = classnamesLib as any
export const flexGrow: TUtilityFunction<TFlexGrow> = classnamesLib as any
export const flexShrink: TUtilityFunction<TFlexShrink> = classnamesLib as any
export const order: TUtilityFunction<TOrder> = classnamesLib as any

//////////// Grid Utility functions

export const gridAutoFlow: TUtilityFunction<TGridAutoFlow> = classnamesLib as any
export const gridTemplateColumns: TUtilityFunction<TGridTemplateColumns> = classnamesLib as any
export const gridAutoColumns: TUtilityFunction<TGridAutoColumns> = classnamesLib as any
export const gridColumn: TUtilityFunction<TGridColumn> = classnamesLib as any
export const gridColumnStart: TUtilityFunction<TGridColumnStart> = classnamesLib as any
export const gridColumnEnd: TUtilityFunction<TGridColumnEnd> = classnamesLib as any
export const gridTemplateRows: TUtilityFunction<TGridTemplateRows> = classnamesLib as any
export const gridAutoRows: TUtilityFunction<TGridAutoRows> = classnamesLib as any
export const gridRow: TUtilityFunction<TGridRow> = classnamesLib as any
export const gridRowStart: TUtilityFunction<TGridRowStart> = classnamesLib as any
export const gridRowEnd: TUtilityFunction<TGridRowEnd> = classnamesLib as any
export const gap: TUtilityFunction<TGap> = classnamesLib as any

//////////// Grouping Utility functions

export const group: TUtilityFunction<TGroup> = classnamesLib as any
export const peer: TUtilityFunction<TPeer> = classnamesLib as any

//////////// Spacing Utility functions

export const padding: TUtilityFunction<TPadding> = classnamesLib as any
export const margin: TUtilityFunction<TMargin> = classnamesLib as any
export const space: TUtilityFunction<TSpace> = classnamesLib as any

//////////// Interactivity Utility functions

export const appearance: TUtilityFunction<TAppearance> = classnamesLib as any
export const pointerEvents: TUtilityFunction<TPointerEvents> = classnamesLib as any
export const resize: TUtilityFunction<TResize> = classnamesLib as any
export const userSelect: TUtilityFunction<TUserSelect> = classnamesLib as any
export const scrollSnap: TUtilityFunction<TScrollSnap> = classnamesLib as any
export const scrollBehavior: TUtilityFunction<TScrollBehavior> = classnamesLib as any
export const touchAction: TUtilityFunction<TTouchAction> = classnamesLib as any
export const cursor: TUtilityFunction<TCursor> = classnamesLib as any
export const caretColor: TUtilityFunction<TCaretColor> = classnamesLib as any
export const willChange: TUtilityFunction<TWillChange> = classnamesLib as any
export const accentColor: TUtilityFunction<TAccentColor> = classnamesLib as any
export const scrollPadding: TUtilityFunction<TScrollPadding> = classnamesLib as any
export const scrollMargin: TUtilityFunction<TScrollMargin> = classnamesLib as any

//////////// Layout Utility functions

export const display: TUtilityFunction<TDisplay> = classnamesLib as any
export const boxDecorationBreak: TUtilityFunction<TBoxDecorationBreak> = classnamesLib as any
export const boxSizing: TUtilityFunction<TBoxSizing> = classnamesLib as any
export const container: TUtilityFunction<TContainer> = classnamesLib as any
export const float: TUtilityFunction<TFloat> = classnamesLib as any
export const clear: TUtilityFunction<TClear> = classnamesLib as any
export const isolation: TUtilityFunction<TIsolation> = classnamesLib as any
export const objectFit: TUtilityFunction<TObjectFit> = classnamesLib as any
export const overflow: TUtilityFunction<TOverflow> = classnamesLib as any
export const overscrollBehavior: TUtilityFunction<TOverscrollBehavior> = classnamesLib as any
export const position: TUtilityFunction<TPosition> = classnamesLib as any
export const visibility: TUtilityFunction<TVisibility> = classnamesLib as any
export const breakBefore: TUtilityFunction<TBreakBefore> = classnamesLib as any
export const breakInside: TUtilityFunction<TBreakInside> = classnamesLib as any
export const breakAfter: TUtilityFunction<TBreakAfter> = classnamesLib as any
export const objectPosition: TUtilityFunction<TObjectPosition> = classnamesLib as any
export const inset: TUtilityFunction<TInset> = classnamesLib as any
export const zIndex: TUtilityFunction<TZIndex> = classnamesLib as any
export const aspectRatio: TUtilityFunction<TAspectRatio> = classnamesLib as any
export const columns: TUtilityFunction<TColumns> = classnamesLib as any

//////////// Sizing Utility functions

export const width: TUtilityFunction<TWidth> = classnamesLib as any
export const minWidth: TUtilityFunction<TMinWidth> = classnamesLib as any
export const maxWidth: TUtilityFunction<TMaxWidth> = classnamesLib as any
export const height: TUtilityFunction<THeight> = classnamesLib as any
export const minHeight: TUtilityFunction<TMinHeight> = classnamesLib as any
export const maxHeight: TUtilityFunction<TMaxHeight> = classnamesLib as any

//////////// SVG Utility functions

export const fill: TUtilityFunction<TFill> = classnamesLib as any
export const stroke: TUtilityFunction<TStroke> = classnamesLib as any
export const strokeWidth: TUtilityFunction<TStrokeWidth> = classnamesLib as any

//////////// Transforms Utility functions

export const hardwareAcceleration: TUtilityFunction<THardwareAcceleration> = classnamesLib as any
export const scale: TUtilityFunction<TScale> = classnamesLib as any
export const rotate: TUtilityFunction<TRotate> = classnamesLib as any
export const translate: TUtilityFunction<TTranslate> = classnamesLib as any
export const skew: TUtilityFunction<TSkew> = classnamesLib as any
export const transformOrigin: TUtilityFunction<TTransformOrigin> = classnamesLib as any

//////////// Typography Utility functions

export const fontSmoothing: TUtilityFunction<TFontSmoothing> = classnamesLib as any
export const fontStyle: TUtilityFunction<TFontStyle> = classnamesLib as any
export const fontVariantNumeric: TUtilityFunction<TFontVariantNumeric> = classnamesLib as any
export const listStylePosition: TUtilityFunction<TListStylePosition> = classnamesLib as any
export const textAlign: TUtilityFunction<TTextAlign> = classnamesLib as any
export const textDecoration: TUtilityFunction<TTextDecoration> = classnamesLib as any
export const textTransform: TUtilityFunction<TTextTransform> = classnamesLib as any
export const textOverflow: TUtilityFunction<TTextOverflow> = classnamesLib as any
export const verticalAlign: TUtilityFunction<TVerticalAlign> = classnamesLib as any
export const whitespace: TUtilityFunction<TWhitespace> = classnamesLib as any
export const wordBreak: TUtilityFunction<TWordBreak> = classnamesLib as any
export const textDecorationStyle: TUtilityFunction<TTextDecorationStyle> = classnamesLib as any
export const fontFamily: TUtilityFunction<TFontFamily> = classnamesLib as any
export const fontSize: TUtilityFunction<TFontSize> = classnamesLib as any
export const fontWeight: TUtilityFunction<TFontWeight> = classnamesLib as any
export const letterSpacing: TUtilityFunction<TLetterSpacing> = classnamesLib as any
export const lineHeight: TUtilityFunction<TLineHeight> = classnamesLib as any
export const listStyleType: TUtilityFunction<TListStyleType> = classnamesLib as any
export const placeholderColor: TUtilityFunction<TPlaceholderColor> = classnamesLib as any
export const placeholderOpacity: TUtilityFunction<TPlaceholderOpacity> = classnamesLib as any
export const textColor: TUtilityFunction<TTextColor> = classnamesLib as any
export const textOpacity: TUtilityFunction<TTextOpacity> = classnamesLib as any
export const content: TUtilityFunction<TContent> = classnamesLib as any
export const textIndent: TUtilityFunction<TTextIndent> = classnamesLib as any
export const textDecorationColor: TUtilityFunction<TTextDecorationColor> = classnamesLib as any
export const textDecorationThickness: TUtilityFunction<TTextDecorationThickness> = classnamesLib as any
export const textUnderlineOffset: TUtilityFunction<TTextUnderlineOffset> = classnamesLib as any

//////////// Accessibility Utility functions

export const accessibility: TUtilityFunction<TAccessibility> = classnamesLib as any


//////////// Backgrounds Utility functions

export const backgrounds: TUtilityFunction<TBackgrounds> = classnamesLib as any


//////////// Borders Utility functions

export const borders: TUtilityFunction<TBorders> = classnamesLib as any


//////////// Tables Utility functions

export const tables: TUtilityFunction<TTables> = classnamesLib as any


//////////// Effects Utility functions

export const effects: TUtilityFunction<TEffects> = classnamesLib as any


//////////// TransitionsAndAnimations Utility functions

export const transitionsAndAnimations: TUtilityFunction<TTransitionsAndAnimations> = classnamesLib as any


//////////// Filters Utility functions

export const filters: TUtilityFunction<TFilters> = classnamesLib as any


//////////// FlexBox Utility functions

export const flexBox: TUtilityFunction<TFlexBox> = classnamesLib as any


//////////// Grid Utility functions

export const grid: TUtilityFunction<TGrid> = classnamesLib as any


//////////// Grouping Utility functions

export const grouping: TUtilityFunction<TGrouping> = classnamesLib as any


//////////// Spacing Utility functions

export const spacing: TUtilityFunction<TSpacing> = classnamesLib as any


//////////// Interactivity Utility functions

export const interactivity: TUtilityFunction<TInteractivity> = classnamesLib as any


//////////// Layout Utility functions

export const layout: TUtilityFunction<TLayout> = classnamesLib as any


//////////// Sizing Utility functions

export const sizing: TUtilityFunction<TSizing> = classnamesLib as any


//////////// SVG Utility functions

export const svg: TUtilityFunction<TSVG> = classnamesLib as any


//////////// Transforms Utility functions

export const transforms: TUtilityFunction<TTransforms> = classnamesLib as any


//////////// Typography Utility functions

export const typography: TUtilityFunction<TTypography> = classnamesLib as any

export const TW = {
  screenReaders,
  backgroundAttachment,
  backgroundClip,
  backgroundOrigin,
  backgroundRepeat,
  backgroundOpacity,
  backgroundColor,
  backgroundPosition,
  backgroundSize,
  backgroundImage,
  gradientColorStops,
  borderStyle,
  divideStyle,
  outlineStyle,
  borderColor,
  borderOpacity,
  borderRadius,
  borderWidth,
  divideColor,
  divideOpacity,
  divideWidth,
  ringColor,
  ringWidth,
  ringOpacity,
  ringOffsetColor,
  ringOffsetWidth,
  outlineOffset,
  outlineWidth,
  outlineColor,
  borderCollapse,
  tableLayout,
  mixBlendMode,
  backgroundBlendMode,
  boxShadow,
  boxShadowColor,
  opacity,
  transitionProperty,
  transitionDuration,
  transitionTimingFunction,
  transitionDelay,
  animation,
  filter,
  backdropFilter,
  blur,
  brightness,
  contrast,
  dropShadow,
  grayscale,
  hueRotate,
  invert,
  saturate,
  sepia,
  backdropBlur,
  backdropBrightness,
  backdropContrast,
  backdropGrayscale,
  backdropHueRotate,
  backdropInvert,
  backdropOpacity,
  backdropSaturate,
  backdropSepia,
  flexDirection,
  flexWrap,
  alignItems,
  alignContent,
  alignSelf,
  placeContent,
  placeItems,
  placeSelf,
  justifyContent,
  justifyItems,
  justifySelf,
  flex,
  flexBasis,
  flexGrow,
  flexShrink,
  order,
  gridAutoFlow,
  gridTemplateColumns,
  gridAutoColumns,
  gridColumn,
  gridColumnStart,
  gridColumnEnd,
  gridTemplateRows,
  gridAutoRows,
  gridRow,
  gridRowStart,
  gridRowEnd,
  gap,
  group,
  peer,
  padding,
  margin,
  space,
  appearance,
  pointerEvents,
  resize,
  userSelect,
  scrollSnap,
  scrollBehavior,
  touchAction,
  cursor,
  caretColor,
  willChange,
  accentColor,
  scrollPadding,
  scrollMargin,
  display,
  boxDecorationBreak,
  boxSizing,
  container,
  float,
  clear,
  isolation,
  objectFit,
  overflow,
  overscrollBehavior,
  position,
  visibility,
  breakBefore,
  breakInside,
  breakAfter,
  objectPosition,
  inset,
  zIndex,
  aspectRatio,
  columns,
  width,
  minWidth,
  maxWidth,
  height,
  minHeight,
  maxHeight,
  fill,
  stroke,
  strokeWidth,
  hardwareAcceleration,
  scale,
  rotate,
  translate,
  skew,
  transformOrigin,
  fontSmoothing,
  fontStyle,
  fontVariantNumeric,
  listStylePosition,
  textAlign,
  textDecoration,
  textTransform,
  textOverflow,
  verticalAlign,
  whitespace,
  wordBreak,
  textDecorationStyle,
  fontFamily,
  fontSize,
  fontWeight,
  letterSpacing,
  lineHeight,
  listStyleType,
  placeholderColor,
  placeholderOpacity,
  textColor,
  textOpacity,
  content,
  textIndent,
  textDecorationColor,
  textDecorationThickness,
  textUnderlineOffset
}

export const CN = {
  accessibility,
  backgrounds,
  borders,
  tables,
  effects,
  transitionsAndAnimations,
  filters,
  flexBox,
  grid,
  grouping,
  spacing,
  interactivity,
  layout,
  sizing,
  svg,
  transforms,
  typography
}

export const mainCategoriesUtilityFunctions = CN;

export const subCategoriesUtilityFunctions = TW;

export type TTailwindString = "TAILWIND_STRING"

export type TArg =
| null
| undefined
| TTailwindString
| TCustomClassesFromExternalFile

export type TTailwind = (...args: TArg[]) => TTailwindString

export const classnames: TTailwind = classnamesLib as any

export default classnames